webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getParam; });
/* unused harmony export transformLineBreak */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return magicLink; });
var getParam = function getParam(paramName) {
  var paramValue = "",
      isFound = !1;
  if (window.location.search.indexOf("?") == 0 && window.location.search.indexOf("=") > 1) {
    var arrSource = unescape(window.location.search).substring(1, window.location.search.length).split("&"),
        i = 0;
    while (i < arrSource.length && !isFound) {
      arrSource[i].indexOf("=") > 0 && arrSource[i].split("=")[0].toLowerCase() == paramName.toLowerCase() && (paramValue = arrSource[i].split("=")[1], isFound = !0), i++;
    }
  }
  return paramValue == "" && (paramValue = null), paramValue;
};

var transformLineBreak = function transformLineBreak(str) {
  var transformed = str.replace(/\n/ig, '<br />');
  return transformed;
};

var salt = "kImzJHT6HutJQ9d6YrBWBRXB2JHLcw3t"; //固定
var prefix = "https://a.app.qq.com/o/simple.jsp?pkgname=com.xizi.quan&android_schema="; //固定
var schema = "xiziquan://com.xizi.quan"; //固定


/* 
安卓 type
webDetail, webview 
postPublish, 发帖 (对应data应该是fid=1{板块id}&special=10{爆料贴的类型})
personDetail, 个人中心（data是 uid=xxx  跳自己则不带data）
poPublish, 唤起发po （  data是 tag_id=xxx  无话题不带data）
tagDetail 唤起 话题 （ data是 tag_id=xxx  不指定不带data）
channelDetail 唤起栏目 （data是 id=xxx）
forumDetail  唤起板块 （指定板块data是fid=xxx ，否则不带）
livePageDetail 唤醒生活 现同城服务页面
popups 唤醒应用弹窗 
*/

/*
ios
web, webview 
post, 发帖 (对应data应该是fid=1{板块id}&special=10{爆料贴的类型})
user, 个人中心（data是 uid=xxx  跳自己则不带data）
po_post, 唤起发po （  data是 tag_id=xxx  无话题不带data）
po_tag 唤起 话题 （ data是 tag_id=xxx  不指定不带data）
channel 唤起栏目 （data是 id=xxx）
forum  唤起板块 （指定板块data是fid=xxx ，否则不带）
live 唤醒生活 现同城服务页面
popups 唤醒应用弹窗 
*/

var magicLink = function magicLink(type, data) {

  var apiMap = {
    web: "webDetail", post: "postPublish", user: "personDetail", po_post: "poPublish",
    po_tag: "poTagDetail", channel: "channelDetail",
    forum: "forumDetail", live: "livePageDetail", popups: "popups", po: "poDetail"
  };

  type = window.OS === 'ios' ? type : apiMap[type];
  var href = '';
  if (window.OS === 'android') {
    if (type === 'webDetail') {
      var _url = encodeURIComponent(data);
      var hash = md5(data + salt);
      data = "id=" + _url + "&hash=" + hash;
    }
    var format = "/" + type + "?" + data;
    href = prefix + encodeURIComponent(schema + format);
  } else {
    href = "https://link.xizi.com/quan_to/" + type + (data ? "?" + data : '');
  }
  location.href = href;
};



/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(98)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(126),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d06caa02",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(89)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(117),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-561ebd24",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(95)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(123),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-735275fe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(94)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(122),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6ea34f9e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(85)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(113),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-22ccf8e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(86)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(114),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-261b0898",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('timestamp2txt', function (timestamp) {
    timestamp = parseInt(timestamp);
    var oDate = new Date(timestamp * 1000);
    var y = oDate.getFullYear();
    var m = oDate.getMonth() + 1;
    var d = oDate.getDate();
    var hour = oDate.getHours();
    var min = oDate.getMinutes();

    var curDate = new Date();
    var cy = curDate.getFullYear();
    var cm = curDate.getMonth() + 1;
    var cd = curDate.getDate();

    var pre = '';
    console.info(y, cy);
    if (y !== cy) {
        pre = y + '-' + numFormat(m) + '-' + numFormat(d);
    } else {
        pre = numFormat(m) + '-' + numFormat(d);
    }

    if (y == cy && m == cm) {
        var day = cd - d;
        if (day == 0) {
            pre = '今天';
        } else if (day == 1) {
            pre = '昨天';
        } else if (day == 2) {
            pre = '前天';
        }
    }

    return pre + ' ' + numFormat(hour) + ':' + numFormat(min);
});

function numFormat(num) {
    return parseInt(num) < 10 ? '0' + num : num;
}

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_topic_Topic_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_topic_Topic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_topic_Topic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_detail_Detail_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_detail_Detail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_detail_Detail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_newDetail_newDetail_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_newDetail_newDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_newDetail_newDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_newTopic_Topic_vue__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_newTopic_Topic_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_newTopic_Topic_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_tagList_tagList_vue__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_tagList_tagList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_tagList_tagList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_map_map_vue__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_map_map_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_map_map_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_lottery_lottery_vue__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_lottery_lottery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_lottery_lottery_vue__);










var routes = [{
  path: '/topic/:tag_id',
  name: 'topic',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_topic_Topic_vue___default.a
}, {
  path: '/detail/:po_id',
  name: 'detail',
  component: __WEBPACK_IMPORTED_MODULE_3__pages_detail_Detail_vue___default.a
}, {
  path: '/newDetail/:po_id/:from_admin?',
  name: 'newDetail',
  component: __WEBPACK_IMPORTED_MODULE_4__pages_newDetail_newDetail_vue___default.a
}, {
  path: '/newTopic/:tag_id',
  name: 'newTopic',
  component: __WEBPACK_IMPORTED_MODULE_5__pages_newTopic_Topic_vue___default.a
}, {
  path: '/tag-list/:tid',
  name: 'tagList',
  component: __WEBPACK_IMPORTED_MODULE_6__pages_tagList_tagList_vue___default.a
}, {
  path: '/map/:log/:lat',
  name: 'map',
  component: __WEBPACK_IMPORTED_MODULE_7__pages_map_map_vue___default.a
}, {
  path: '/lottery/:po_id',
  name: 'lottery',
  component: __WEBPACK_IMPORTED_MODULE_8__pages_lottery_lottery_vue___default.a
}];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // mode: 'history', //html5模式 去掉锚点
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },

  routes: routes // short for `routes: routes`
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(87)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(115),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            ifShow: true
        };
    },

    methods: {
        openApp: function openApp() {
            var self = this;
            switch (self.$route.name) {
                case 'topic':
                    location.href = 'https://www.xiziquan.com/quan_to.php?type=po_tag&tag_id=' + self.$route.params.tag_id;
                    break;
                case 'detail':
                    location.href = 'https://www.xiziquan.com/quan_to.php?type=po&pid=' + self.$route.params.po_id;
                    break;
                default:
                    location.href = "https://www.xiziquan.com/quan_to.php";
                    break;
            }
        }
    },
    mounted: function mounted() {
        var self = this;
        //主引导下载悬浮栏
        var preScrollTop = 0;
        var oNav = document.querySelector('.download_nav');
        var h = oNav.offsetHeight;
        window.addEventListener('scroll', function () {
            var sTop = document.body.scrollTop;
            if (sTop - preScrollTop > 0 && sTop > h) {
                self.ifShow = false;
            } else {
                self.ifShow = true;
            }
            preScrollTop = sTop;
        });
    }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__untils_until_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },
  created: function created() {},

  props: ["ifShow"],
  methods: {
    openApp: function openApp() {
      var self = this;
      switch (self.$route.name) {
        case "newTopic":
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__untils_until_js__["b" /* magicLink */])("po_tag", window.OS === "ios" ? "tag_id=" + this.$route.params.tag_id : "id=" + this.$route.params.tag_id);
          break;
        case "newDetail":
          var data = window.OS === "ios" ? "pid=" + this.$route.params.po_id : "id=" + this.$route.params.po_id + "&type=" + this.$parent.poData.type;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__untils_until_js__["b" /* magicLink */])("po", data);
          break;
        default:
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__untils_until_js__["b" /* magicLink */])("po", "xid=0");
          break;
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      ifOpenVideo: false,
      videoSrc: "",
      deviceWidth: 750
    };
  },

  computed: {},
  mounted: function mounted() {
    this.deviceWidth = this.$refs.pic_container.clientWidth;
  },

  props: {
    images: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    type: {
      type: String,
      default: "1"
    }
  },
  methods: {
    // 查看po图片
    onReadPoImg: function onReadPoImg(pic_index) {
      var self = this;
      var urls = [];
      var imgs = self.images;
      var curUrl = imgs[pic_index].hd_url;
      imgs.forEach(function (item) {
        urls.push(item.hd_url);
      });
      wx.previewImage({
        current: curUrl, // 当前显示图片的http链接
        urls: urls // 需要预览的图片http链接列表
      });
    },
    onOpenVideo: function onOpenVideo(url) {
      var self = this;
      self.videoSrc = url;
      self.ifOpenVideo = true;
    },
    closeVideo: function closeVideo() {
      this.ifOpenVideo = false;
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      lineLeft: 0
    };
  },

  props: {
    active: {
      type: Number,
      default: 0
    },
    tabs: {
      type: Array,
      default: function _default() {
        return ["选项卡1", "选项卡2"];
      }
    }
  },
  methods: {
    changeTab: function changeTab(e) {
      this.$emit("change", e.target.dataset.index);
      this.lineLeft = e.target.offsetLeft + (this.tabW - this.lineW) / 2;
    }
  },
  mounted: function mounted() {
    this.tabW = this.$refs["tab_" + this.active][0].offsetWidth;
    this.tabL = this.$refs["tab_" + this.active][0].offsetLeft;
    this.lineW = this.$refs.line.offsetWidth;

    this.lineLeft = this.tabL + (this.tabW - this.lineW) / 2;
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      lineLeft: 0
    };
  },

  props: {
    active: {
      type: Number,
      default: 0
    },
    tabs: {
      type: Array,
      default: function _default() {
        return ["选项卡1", "选项卡2", "标签"];
      }
    }
  },
  methods: {
    changeTab: function changeTab(e, index) {
      var emit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var _index = index;
      var offsetLeft = this.$refs["tab_" + index][0].offsetLeft;
      if (e) {
        _index = e.target.dataset.index;
        offsetLeft = e.target.offsetLeft;
      }
      if (emit) {
        this.$emit("change", _index);
      }
      this.lineLeft = offsetLeft + (this.tabW - this.lineW) / 2;
    }
  },
  mounted: function mounted() {
    this.tabW = this.$refs["tab_" + this.active][0].offsetWidth;
    this.tabL = this.$refs["tab_" + this.active][0].offsetLeft;
    this.lineW = this.$refs.line.offsetWidth;

    this.lineLeft = this.tabL + (this.tabW - this.lineW) / 2;
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_download_nav_DownloadNav_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_download_nav_DownloadNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_download_nav_DownloadNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pic_box_PicBox_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pic_box_PicBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pic_box_PicBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cutscenes_Cutscenes_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cutscenes_Cutscenes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_cutscenes_Cutscenes_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__untils_until_js__ = __webpack_require__(4);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var qs = __webpack_require__(3);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  data: function data() {
    return {
      showCutscenes: true,
      poData: null,
      page: 0
    };
  },

  components: {
    DownloadNav: __WEBPACK_IMPORTED_MODULE_2__components_download_nav_DownloadNav_vue___default.a,
    PicBox: __WEBPACK_IMPORTED_MODULE_3__components_pic_box_PicBox_vue___default.a,
    Cutscenes: __WEBPACK_IMPORTED_MODULE_4__components_cutscenes_Cutscenes_vue___default.a
  },
  created: function created() {
    var self = this;
    var obj = {
      params: {
        id: this.$route.params.po_id,
        page: this.page
      }
    };
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__untils_until_js__["a" /* getParam */])("from") != null) {
      obj.params.from = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__untils_until_js__["a" /* getParam */])("from");
    }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__untils_until_js__["a" /* getParam */])("isappinstalled") != null) {
      obj.params.isappinstalled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__untils_until_js__["a" /* getParam */])("isappinstalled");
    }

    var api = "/index.php?r=web/ajaxpostinfo&v=4.2.0";
    var reqData = {
      data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj)
    };
    self.axios.post(api, qs.stringify(reqData), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    }).then(function (response) {
      var resBody = response.data;
      if (resBody.ret == 0) {
        resBody.data.content = resBody.data.content.replace(/\n/ig, '<br />');
        self.poData = resBody.data;
        self.showCutscenes = false;
        wx.ready(function () {
          wx.onMenuShareTimeline({
            title: resBody.data.content,
            link: resBody.data.share_url,
            imgUrl: resBody.data.images && resBody.data.images[0] ? resBody.data.images[0].url : ""
          });
          wx.onMenuShareAppMessage({
            title: resBody.data.content,
            desc: "惠州生活必备-西子湖畔App",
            link: resBody.data.share_url,
            imgUrl: resBody.data.images && resBody.data.images[0] ? resBody.data.images[0].url : ""
          });
        });
      }
    });
  },

  methods: {
    loadComment: function loadComment() {
      var self = this;
      var page = self.page + 1;

      var api = "/index.php?r=web/ajaxpostinfo&v=4.2.0";
      var obj = {
        params: {
          id: this.$route.params.po_id,
          page: this.page
        }
      };
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__untils_until_js__["a" /* getParam */])("from") != null) {
        obj.params.from = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__untils_until_js__["a" /* getParam */])("from");
      }
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__untils_until_js__["a" /* getParam */])("isappinstalled") != null) {
        obj.params.isappinstalled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__untils_until_js__["a" /* getParam */])("isappinstalled");
      }
      var reqData = {
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj)
      };

      self.axios.post(api, qs.stringify(reqData), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(function (response) {
        var resBody = response.data;
        if (resBody.ret == 0) {
          self.poData.comments = self.poData.comments.concat(resBody.data.comments);
          self.page = page;
        }
      });
    },
    onZan: function onZan() {
      var self = this;
      if (!globalData.isLogin) {
        window.location.href = "http://my2.xizi.com/user/social-login?type=wx&referrer=" + encodeURIComponent(location.href);
        return;
      }
      var api = "/index.php?r=web/ajaxpraise&v=4.2.0";
      var preZanState = self.poData.is_praise;
      var reqData = {
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
          params: {
            id: self.$route.params.po_id,
            qx: preZanState // 0 点赞 1取消点赞
          }
        })
      };
      self.poData.is_praise = preZanState == 0 ? 1 : 0;
      self.axios.post(api, qs.stringify(reqData), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(function (response) {
        var resBody = response.data;
        console.log(resBody);
        if (resBody.ret !== 0) {
          self.poData.is_praise = preZanState;
        }
      }).catch(function () {
        self.poData.is_praise = preZanState;
      });
    },
    openAppPoTopic: function openAppPoTopic(tag_id) {
      location.href = "https://www.xiziquan.com/quan_to.php?type=po_tag&tag_id=" + tag_id;
    },
    openApp: function openApp() {
      var self = this;
      location.href = "https://www.xiziquan.com/quan_to.php?type=po&pid=" + self.$route.params.po_id;
    },
    formatSticker: function formatSticker() {
      var potxt = document.querySelectorAll(".po_txt");
      var commentTxt = document.querySelectorAll(".comment-txt");

      if (potxt.length) {
        var txtFontSize = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(window.getComputedStyle(potxt[0], null).fontSize.split("px")[0]);
        this.forCircle(potxt, txtFontSize);
      }
      if (commentTxt.length) {
        var commentFontSize = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(window.getComputedStyle(commentTxt[0], null).fontSize.split("px")[0]);
        this.forCircle(commentTxt, commentFontSize);
      }
    },
    forCircle: function forCircle(item, fontSize) {
      for (var i = 0, length = item.length; i < length; i++) {
        var img = item[i].querySelectorAll("img");
        if (img.length) {
          for (var j = 0, _length = img.length; j < _length; j++) {
            img[j].style.width = fontSize + "px";
            img[j].style.height = fontSize + "px";
          }
        }
      }
    }
  },
  mounted: function mounted() {
    document.title = "详情";
    // this.wxConfig();
  },
  updated: function updated() {
    this.formatSticker();
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_swipe_item_style_css__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_swipe_item_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_swipe_item_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_swipe_item__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_swipe_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_swipe_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_swipe_style_css__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_swipe_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_swipe_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_swipe__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_swipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_swipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_download_tab_DownloadNav_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_download_tab_DownloadNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_download_tab_DownloadNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pic_box_PicBox_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pic_box_PicBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pic_box_PicBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_cutscenes_Cutscenes_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_cutscenes_Cutscenes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_cutscenes_Cutscenes_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__untils_until_js__ = __webpack_require__(4);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var qs = __webpack_require__(3);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  data: function data() {
    return {
      showCutscenes: true,
      poData: {
        id: "",
        address: "",
        content: "",
        dateline: "",
        views: "0",
        reply_num: "0",
        type: "",
        uid: "",
        tag_id: "",
        sticker: "",
        praise_count: "0",
        top_user: "0",
        ifcheck: "1",
        images: [],
        cover: {},
        user: {},
        collect_count: "0",
        is_collect: "0",
        tag: {},
        labels: [],
        share: {},
        praise: [],
        top_title: "",
        is_praise: 0,
        comments: [],
        comment_count: "0"
      },
      page: 1,
      swipeIndex: 0,
      waterFall: {
        col_0: [],
        col_1: [],
        short: 0
      },
      loaded: false,
      hotList: [],
      isVideo: false,
      playing: false,
      ifShow: false,
      noMoreData: false,
      lotteries: []
    };
  },

  components: {
    DownloadNav: __WEBPACK_IMPORTED_MODULE_5__components_download_tab_DownloadNav_vue___default.a,
    PicBox: __WEBPACK_IMPORTED_MODULE_6__components_pic_box_PicBox_vue___default.a,
    Cutscenes: __WEBPACK_IMPORTED_MODULE_7__components_cutscenes_Cutscenes_vue___default.a,
    Swipe: __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_swipe___default.a,
    SwipeItem: __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_swipe_item___default.a
  },
  watch: {
    $route: function $route(route) {
      var params = route.params;
      this.page = params.po_id;
    }
  },
  created: function created() {
    var _this = this;

    var self = this;
    var obj = {
      params: {
        id: this.$route.params.po_id,
        page: this.page
      }
    };
    if (this.$route.query.isVideo == 1) {
      this.isVideo = true;
    }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["a" /* getParam */])("from") != null) {
      obj.params.from = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["a" /* getParam */])("from");
    }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["a" /* getParam */])("isappinstalled") != null) {
      obj.params.isappinstalled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["a" /* getParam */])("isappinstalled");
    }
    var api = "/index.php?r=web/postinfo&v=4.7.0";
    var reqData = {
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj)
    };
    this.loaded = false;
    this.axios.post(api, qs.stringify(reqData), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    }).then(function (response) {
      var resBody = response.data;
      if (resBody.ret == 0) {
        _this.hotList = resBody.data.recommends;

        _this.poData = resBody.data.info;
        _this.isVideo = resBody.data.info.type == 1 ? false : true;
        _this.showCutscenes = false;
        _this.page = 2;
        __WEBPACK_IMPORTED_MODULE_8_vue__["default"].nextTick(function () {
          self.loaded = true;
          self.formatSticker(".comment-txt");
          self.formatSticker(".post-content");
        });

        wx.ready(function () {
          wx.onMenuShareTimeline({
            title: resBody.data.info.share.share_title,
            link: resBody.data.info.share.share_url,
            imgUrl: resBody.data.info.share.share_image_url
          });
          wx.onMenuShareAppMessage({
            title: resBody.data.info.share.share_title,
            desc: "惠州生活必备-西子湖畔App",
            link: resBody.data.info.share.share_url,
            imgUrl: resBody.data.info.share.share_image_url
          });
        });
      }
    });
    var lotteryObj = {
      params: {
        po_id: this.$route.params.po_id,
        page: 1
      }
    };
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["a" /* getParam */])("from") != null) {
      lotteryObj.params.from = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["a" /* getParam */])("from");
    }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["a" /* getParam */])("isappinstalled") != null) {
      lotteryObj.params.isappinstalled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["a" /* getParam */])("isappinstalled");
    }
    var lotteryParams = {
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(lotteryObj)
    };
    this.axios.post('/index.php?r=web/getPraiseUsers&v=4.7.0', qs.stringify(lotteryParams), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    }).then(function (response) {
      var res = response.data;
      if (res.ret == 0) {
        _this.lotteries = res.data;
      }
    });
  },

  methods: {
    toLabel: function toLabel(tid) {
      this.$router.push({ name: "tagList", params: { tid: tid } });
      console.info(lid);
    },
    toTag: function toTag(tid) {
      this.$router.push({ name: "newTopic", params: { tag_id: tid } });
    },
    downApp: function downApp() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["b" /* magicLink */])('po', 'pid=' + this.$route.params.po_id);
    },
    ended: function ended() {
      this.playing = false;
    },
    playVideo: function playVideo() {
      if (this.$refs.video.paused) {
        this.$refs.video.play();
        this.playing = true;
      } else {
        this.$refs.video.pause();
        this.playing = false;
      }
    },
    renderWaterFall: function renderWaterFall(data) {
      var self = this;
      self.waterFall = {
        col_0: [],
        col_1: [],
        short: 0
      };

      if (!data.length) {
        return;
      }
      var index = 0;
      var len = data.length;
      var w = self.$refs.col_0.offsetWidth;
      calcWaterFall(data);
      function calcWaterFall(data) {
        var item = data[index];
        var imgRatio = item.cover.h / item.cover.w;
        var imgW = w;
        var imgH = w * imgRatio;
        item.cover.w = imgW;
        item.cover.h = imgH;

        self.waterFall["col_" + self.waterFall.short].push(item);
        __WEBPACK_IMPORTED_MODULE_8_vue__["default"].nextTick(function () {
          var h0 = self.$refs.col_0.offsetHeight;
          var h1 = self.$refs.col_1.offsetHeight;
          self.waterFall.short = h0 <= h1 ? 0 : 1;
          index++;

          if (index >= data.length) {
            self.formatSticker(".desc ");

            return;
          }
          calcWaterFall(data);
        });
      }
    },
    jumpPoDetail: function jumpPoDetail(id) {
      this.$router.push({ name: "newDetail", params: { po_id: id } });
      window.location.reload();
    },
    handleChange: function handleChange(index) {
      this.swipeIndex = index;
      console.info(index);
    },

    // 加载po列表数据
    loadPoListData: function loadPoListData(page, cb) {
      var _this2 = this;

      var api = "/index.php?r=web/postinfo&v=4.7.0";
      var reqData = {};
      var obj = {
        params: {}
      };
      obj.params = {
        page: page,
        id: this.$route.params.po_id
      };
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["a" /* getParam */])("from") != null) {
        obj.params.from = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["a" /* getParam */])("from");
      }
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["a" /* getParam */])("isappinstalled") != null) {
        obj.params.isappinstalled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["a" /* getParam */])("isappinstalled");
      }

      reqData = { data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj) };
      if (!this.loaded) {
        return;
      }
      this.loaded = false;
      this.axios.post(api, qs.stringify(reqData), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(function (res) {
        var resBody = res.data;

        if (resBody.ret == 0) {
          cb && cb(resBody.data.recommends);
        }
        _this2.loaded = true;
      });
    },
    onZan: function onZan() {
      var self = this;
      console.info(globalData);
      if (!globalData.isLogin) {
        window.location.href = "http://my2.xizi.com/user/social-login?type=wx&referrer=" + encodeURIComponent(location.href);
        return;
      }
      var api = "/index.php?r=web/ajaxpraise&v=4.2.0";
      var preZanState = self.poData.is_praise;
      var reqData = {
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          params: {
            id: self.$route.params.po_id,
            qx: preZanState // 0 点赞 1取消点赞
          }
        })
      };
      self.poData.is_praise = preZanState == 0 ? 1 : 0;
      self.axios.post(api, qs.stringify(reqData), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(function (response) {
        var resBody = response.data;
        console.log(resBody);
        if (resBody.ret !== 0) {
          self.poData.is_praise = preZanState;
        }
      }).catch(function () {
        self.poData.is_praise = preZanState;
      });
    },
    openAppPoTopic: function openAppPoTopic(tag_id) {
      location.href = "https://www.xiziquan.com/quan_to.php?type=po_tag&tag_id=" + tag_id;
    },
    openApp: function openApp() {
      var jump = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (jump) {
        var self = this;
        location.href = "https://www.xiziquan.com/quan_to.php?type=po&pid=" + self.$route.params.po_id;
      }
    },
    formatSticker: function formatSticker() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ".desc";

      var html = document.querySelector("html");
      var fontSize = parseFloat(html.style.fontSize);
      var dpr = html.dataset.dpr;
      var imgs = document.querySelectorAll(selector + " img");
      for (var i = 0; i < imgs.length; i++) {
        imgs[i].style.width = 20 * dpr / fontSize + "rem";
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    document.title = "详情";
    //主引导下载悬浮栏
    var preScrollTop = 0;
    var oNav = document.querySelector(".download_nav");
    var h = oNav.offsetHeight;

    window.addEventListener("scroll", function (e) {
      var sTop = document.documentElement.scrollTop || document.body.scrollTop;
      var docH = document.documentElement.scrollHeight || document.body.scrollHeight;
      var winH = document.documentElement.clientHeight || document.body.clientHeight;
      if (sTop == docH - winH && _this3.loaded) {
        _this3.loadPoListData(_this3.page, function (data) {
          if (data.length) {
            _this3.page += 1;
            _this3.hotList = _this3.hotList.concat(data);
          } else {
            _this3.noMoreData = true;
          }
        });
      }
      if (sTop > h) {
        _this3.ifShow = true;
      } else {
        _this3.ifShow = false;
      }
    });
  },
  updated: function updated() {}
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      cacheMeta: "",
      cacheDpr: 1
    };
  },
  created: function created() {},

  methods: {
    goback: function goback() {
      this.$router.go(-1);
    }
  },
  mounted: function mounted() {
    var _$route$params = this.$route.params,
        log = _$route$params.log,
        lat = _$route$params.lat;

    var map = new qq.maps.Map(document.getElementById("map"), {
      // 地图的中心地理坐标。
      center: new qq.maps.LatLng(lat, log),
      zoom: 80
    });
    var scaleControl = new qq.maps.ScaleControl({
      align: qq.maps.ALIGN.BOTTOM_LEFT,
      margin: qq.maps.Size(85, 15),
      map: map
    });
    var marker = new qq.maps.Marker({
      position: new qq.maps.LatLng(lat, log),
      map: map
    });
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_swipe_item_style_css__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_swipe_item_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_swipe_item_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_swipe_item__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_swipe_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_swipe_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_swipe_style_css__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_swipe_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_swipe_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_swipe__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_swipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_swipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_download_tab_DownloadNav_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_download_tab_DownloadNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_download_tab_DownloadNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pic_box_PicBox_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pic_box_PicBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pic_box_PicBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_cutscenes_Cutscenes_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_cutscenes_Cutscenes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_cutscenes_Cutscenes_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__untils_until_js__ = __webpack_require__(4);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var qs = __webpack_require__(3);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  data: function data() {
    return {
      showCutscenes: true,
      from_admin: 0,
      poData: {
        id: "",
        address: "",
        content: "",
        dateline: "",
        views: "0",
        reply_num: "0",
        type: "",
        uid: "",
        tag_id: "",
        sticker: "",
        praise_count: "0",
        top_user: "0",
        ifcheck: "1",
        images: [],
        cover: {},
        user: {},
        collect_count: "0",
        is_collect: "0",
        tag: {},
        labels: [],
        share: {},
        praise: [],
        top_title: "",
        is_praise: 0,
        comments: [],
        comment_count: "0"
      },
      page: 1,
      swipeIndex: 0,
      waterFall: {
        col_0: [],
        col_1: [],
        short: 0
      },
      loaded: false,
      hotList: [],
      isVideo: false,
      playing: false,
      ifShow: false,
      noMoreData: false
    };
  },

  components: {
    DownloadNav: __WEBPACK_IMPORTED_MODULE_5__components_download_tab_DownloadNav_vue___default.a,
    PicBox: __WEBPACK_IMPORTED_MODULE_6__components_pic_box_PicBox_vue___default.a,
    Cutscenes: __WEBPACK_IMPORTED_MODULE_7__components_cutscenes_Cutscenes_vue___default.a,
    Swipe: __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_swipe___default.a,
    SwipeItem: __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_swipe_item___default.a
  },
  watch: {
    $route: function $route(route) {
      var params = route.params;
      this.page = params.po_id;
    }
  },
  created: function created() {
    var _this = this;

    this.from_admin = this.$route.params.from_admin == 1 ? 1 : 0;
    var self = this;
    var obj = {
      params: {
        id: this.$route.params.po_id,
        page: this.page,
        from_admin: this.$route.params.from_admin == 1 ? 1 : 0
      }
    };
    if (this.$route.query.isVideo == 1) {
      this.isVideo = true;
    }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["a" /* getParam */])("from") != null) {
      obj.params.from = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["a" /* getParam */])("from");
    }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["a" /* getParam */])("isappinstalled") != null) {
      obj.params.isappinstalled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["a" /* getParam */])("isappinstalled");
    }
    var api = "/index.php?r=web/postinfo&v=4.7.0";
    var reqData = {
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj)
    };
    this.loaded = false;
    this.axios.post(api, qs.stringify(reqData), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    }).then(function (response) {
      var resBody = response.data;
      if (resBody.ret == 0) {
        _this.hotList = resBody.data.recommends;

        _this.poData = resBody.data.info;
        _this.isVideo = resBody.data.info.type == 1 ? false : true;
        _this.showCutscenes = false;
        _this.page = 2;
        __WEBPACK_IMPORTED_MODULE_8_vue__["default"].nextTick(function () {
          self.loaded = true;
          self.formatSticker(".comment-txt");
          self.formatSticker(".post-content");
          self.renderWaterFall(self.hotList);
        });

        wx.ready(function () {
          wx.onMenuShareTimeline({
            title: resBody.data.info.share.share_title,
            link: resBody.data.info.share.share_url,
            imgUrl: resBody.data.info.share.share_image_url
          });
          wx.onMenuShareAppMessage({
            title: resBody.data.info.share.share_title,
            desc: "惠州生活必备-西子湖畔App",
            link: resBody.data.info.share.share_url,
            imgUrl: resBody.data.info.share.share_image_url
          });
        });
      }
    });
  },

  methods: {
    toLabel: function toLabel(tid) {
      this.$router.push({ name: "tagList", params: { tid: tid } });
      console.info(lid);
    },
    toTag: function toTag(tid) {
      this.$router.push({ name: "newTopic", params: { tag_id: tid } });
    },
    downApp: function downApp() {
      var data = window.OS === "ios" ? "pid=" + this.$route.params.po_id : "id=" + this.$route.params.po_id + "&type=" + this.poData.type;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["b" /* magicLink */])("po", data);
    },
    ended: function ended() {
      this.playing = false;
    },
    playVideo: function playVideo() {
      if (this.$refs.video.paused) {
        this.$refs.video.play();
        this.playing = true;
      } else {
        this.$refs.video.pause();
        this.playing = false;
      }
    },
    renderWaterFall: function renderWaterFall(data) {
      var self = this;
      self.waterFall = {
        col_0: [],
        col_1: [],
        short: 0
      };

      if (!data.length) {
        return;
      }
      var index = 0;
      var len = data.length;
      var w = self.$refs.col_0.offsetWidth;
      calcWaterFall(data);
      function calcWaterFall(data) {
        var item = data[index];
        var imgRatio = item.cover.h / item.cover.w;
        var imgW = w;
        var imgH = w * imgRatio;
        item.cover.w = imgW;
        item.cover.h = imgH;

        self.waterFall["col_" + self.waterFall.short].push(item);
        __WEBPACK_IMPORTED_MODULE_8_vue__["default"].nextTick(function () {
          var h0 = self.$refs.col_0.offsetHeight;
          var h1 = self.$refs.col_1.offsetHeight;
          self.waterFall.short = h0 <= h1 ? 0 : 1;
          index++;

          if (index >= data.length) {
            self.formatSticker(".desc ");

            return;
          }
          calcWaterFall(data);
        });
      }
    },
    jumpPoDetail: function jumpPoDetail(id) {
      this.$router.push({ name: "newDetail", params: { po_id: id } });
      window.location.reload();
    },
    handleChange: function handleChange(index) {
      this.swipeIndex = index;
      console.info(index);
    },

    // 加载po列表数据
    loadPoListData: function loadPoListData(page, cb) {
      var _this2 = this;

      var api = "/index.php?r=web/postinfo&v=4.7.0";
      var reqData = {};
      var obj = {
        params: {}
      };
      obj.params = {
        page: page,
        id: this.$route.params.po_id
      };
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["a" /* getParam */])("from") != null) {
        obj.params.from = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["a" /* getParam */])("from");
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["a" /* getParam */])("isappinstalled") != null) {
        obj.params.isappinstalled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["a" /* getParam */])("isappinstalled");
      }

      reqData = { data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj) };
      if (!this.loaded) {
        return;
      }
      this.loaded = false;
      this.axios.post(api, qs.stringify(reqData), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(function (res) {
        var resBody = res.data;

        if (resBody.ret == 0) {
          cb && cb(resBody.data.recommends);
        }
        _this2.loaded = true;
      });
    },
    onZan: function onZan() {
      var self = this;
      console.info(globalData);
      if (!globalData.isLogin) {
        window.location.href = "http://my2.xizi.com/user/social-login?type=wx&referrer=" + encodeURIComponent(location.href);
        return;
      }
      var api = "/index.php?r=web/ajaxpraise&v=4.2.0";
      var preZanState = self.poData.is_praise;
      var reqData = {
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          params: {
            id: self.$route.params.po_id,
            qx: preZanState // 0 点赞 1取消点赞
          }
        })
      };
      self.poData.is_praise = preZanState == 0 ? 1 : 0;
      self.axios.post(api, qs.stringify(reqData), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(function (response) {
        var resBody = response.data;
        console.log(resBody);
        if (resBody.ret !== 0) {
          self.poData.is_praise = preZanState;
        }
      }).catch(function () {
        self.poData.is_praise = preZanState;
      });
    },
    openAppPoTopic: function openAppPoTopic(tag_id) {
      location.href = "https://www.xiziquan.com/quan_to.php?type=po_tag&tag_id=" + tag_id;
    },
    openApp: function openApp() {
      var jump = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (jump) {
        var self = this;
        location.href = "https://www.xiziquan.com/quan_to.php?type=po&pid=" + self.$route.params.po_id;
      }
    },
    formatSticker: function formatSticker() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ".desc";

      var html = document.querySelector("html");
      var fontSize = parseFloat(html.style.fontSize);
      var dpr = html.dataset.dpr;
      var imgs = document.querySelectorAll(selector + " img");
      for (var i = 0; i < imgs.length; i++) {
        imgs[i].style.width = 20 * dpr / fontSize + "rem";
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    document.title = "详情";
    //主引导下载悬浮栏
    var preScrollTop = 0;
    var oNav = document.querySelector(".download_nav");
    var h = oNav.offsetHeight;

    window.addEventListener("scroll", function (e) {
      var sTop = document.documentElement.scrollTop || document.body.scrollTop;
      var docH = document.documentElement.scrollHeight || document.body.scrollHeight;
      var winH = document.documentElement.clientHeight || document.body.clientHeight;
      if (sTop == docH - winH && _this3.loaded) {
        _this3.loadPoListData(_this3.page, function (data) {
          if (data.length) {
            _this3.page += 1;
            _this3.hotList = _this3.hotList.concat(data);
            __WEBPACK_IMPORTED_MODULE_8_vue__["default"].nextTick(function () {
              _this3.renderWaterFall(_this3.hotList);
            });
          } else {
            _this3.noMoreData = true;
          }
        });
      }
      if (sTop > h) {
        _this3.ifShow = true;
      } else {
        _this3.ifShow = false;
      }
    });
  },
  updated: function updated() {}
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_download_tab_DownloadNav_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_download_tab_DownloadNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_download_tab_DownloadNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tab_nav_new_TabNav_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tab_nav_new_TabNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_tab_nav_new_TabNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_bottom_loading_BottomLoading_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_bottom_loading_BottomLoading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_bottom_loading_BottomLoading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pic_box_PicBox_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pic_box_PicBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pic_box_PicBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_cutscenes_Cutscenes_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_cutscenes_Cutscenes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_cutscenes_Cutscenes_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__untils_until_js__ = __webpack_require__(4);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var qs = __webpack_require__(3);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  data: function data() {
    return {
      showCutscenes: true,
      tabsConfig: {
        tabs: [],
        active: 0
      },
      // 当前选项卡选中的类型
      curTabType: "",

      topicMode: 0, // 0普通话题 其他高级话题
      listMode: 1, // 0普通模式 1瀑布流模式
      ifShowBottomLoading: false,
      allData: null,
      hotData: null,
      activity: null,
      tag_info: null,
      t: null,
      // 普通列表要展示的数据
      normalList: [],
      // 瀑布流列表要展示的数据
      waterFall: {
        col_0: [],
        col_1: [],
        // 高度较短的列的索引
        short: 0
      },

      // 最新
      newestList: [],
      newestPage: 1,
      newestMode: 0,
      // 热门
      hotList: [],
      hotPage: 1,
      hotMode: 0,
      // 排行榜
      rankList: [],
      rankPage: 1,
      rankMode: 0,
      // 标签
      labelList: [],
      labelPage: 1,
      labelMode: 0,
      // 活动倒计时对象
      activityEndTime: null,
      labels: [],
      currIndex: -1,
      prizes: [],
      lid: 0,
      currentKey: "",
      ifShow: false
    };
  },

  components: {
    DownloadNav: __WEBPACK_IMPORTED_MODULE_2__components_download_tab_DownloadNav_vue___default.a,
    TabNav: __WEBPACK_IMPORTED_MODULE_3__components_tab_nav_new_TabNav_vue___default.a,
    BottomLoading: __WEBPACK_IMPORTED_MODULE_4__components_bottom_loading_BottomLoading_vue___default.a,
    PicBox: __WEBPACK_IMPORTED_MODULE_5__components_pic_box_PicBox_vue___default.a,
    Cutscenes: __WEBPACK_IMPORTED_MODULE_6__components_cutscenes_Cutscenes_vue___default.a
  },
  methods: {
    tabLabel: function tabLabel(e) {
      this.currIndex = e.target.dataset.index;
      this.lid = e.target.dataset.lid;
      this.$refs.tabNav.changeTab(null, 2);
      this.$refs.labelContainer.scrollLeft = e.offsetX - this.$refs.labelContainer.offsetWidth / 2;
    },

    // 切换选项卡回调
    tabChanged: function tabChanged(index) {
      var _this = this;

      var self = this;
      this.tabsConfig.active = parseInt(index);
      if (this.topicMode == 0) {
        // 普通话题
        if (index == 0) {
          // 最新
          this.listMode = this.newestMode;
          this.currIndex = -1;
          this.currentKey = "newest";

          if (this.newestMode == 0) {
            this.normalList = this.newestList;
          } else {
            __WEBPACK_IMPORTED_MODULE_7_vue__["default"].nextTick(function () {
              self.renderWaterFall(_this.newestList);
            });
          }
        } else if (index == 1) {
          // 热门
          this.listMode = this.hotMode;
          this.currIndex = -1;
          this.currentKey = "hot";

          if (this.hotMode == 0) {
            this.normalList = this.hotList;
          } else {
            __WEBPACK_IMPORTED_MODULE_7_vue__["default"].nextTick(function () {
              self.renderWaterFall(_this.hotList);
            });
          }
        } else if (index == 2) {
          this.currentKey = "label";
          this.listMode = this.labelMode;
          if (this.labelMode == 0) {
            this.normalList = this.labelList;
          } else {
            __WEBPACK_IMPORTED_MODULE_7_vue__["default"].nextTick(function () {
              self.renderWaterFall(_this.labelList);
            });
          }
        }
      } else {
        // 高级话题
        if (index == 0) {
          // 排行榜
          this.listMode = this.rankMode;
          this.currIndex = -1;
          this.currentKey = "rank";

          if (this.rankMode == 0) {
            this.normalList = this.rankList;
          } else {
            __WEBPACK_IMPORTED_MODULE_7_vue__["default"].nextTick(function () {
              self.renderWaterFall(_this.rankList);
            });
          }
        } else if (index == 1) {
          // 最新
          this.listMode = this.newestMode;
          this.currIndex = -1;
          this.currentKey = "newest";

          if (this.newestMode == 0) {
            this.normalList = this.newestList;
          } else {
            __WEBPACK_IMPORTED_MODULE_7_vue__["default"].nextTick(function () {
              self.renderWaterFall(_this.newestList);
            });
          }
        }
      }
    },

    // 渲染瀑布流
    renderWaterFall: function renderWaterFall(data) {
      var self = this;

      self.waterFall = {
        col_0: [],
        col_1: [],
        short: 0
      };

      if (!data.length) {
        return;
      }
      var index = 0;
      var len = data.length;
      var w = self.$refs.col_0.offsetWidth;
      calcWaterFall(data);
      function calcWaterFall(data) {
        var imgRatio = data[index].cover.h / data[index].cover.w;
        var imgW = w;
        var imgH = w * imgRatio;
        var item = data[index];
        item.cover.w = imgW;
        item.cover.h = imgH;

        self.waterFall["col_" + self.waterFall.short].push(item);
        __WEBPACK_IMPORTED_MODULE_7_vue__["default"].nextTick(function () {
          var h0 = self.$refs.col_0.offsetHeight;
          var h1 = self.$refs.col_1.offsetHeight;
          self.waterFall.short = h0 <= h1 ? 0 : 1;
          index++;
          if (index >= data.length) {
            return;
          }
          calcWaterFall(data);
        });
      }
    },

    // 跳转详情页
    jumpPoDetail: function jumpPoDetail(po_id) {
      this.$router.push("/newDetail/" + po_id);
    },

    // 加载po列表数据
    loadPoListData: function loadPoListData(mode, page) {
      var _this2 = this;

      var first = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var self = this;
      var api = "/index.php?r=web/posttaglist&v=4.7.0";
      var reqData = {};
      var obj = {
        params: {}
      };
      if (mode == "rank") {
        obj.params = {
          page: page,
          tag_id: this.$route.params.tag_id,
          type_id: "2",
          label_id: 0
        };
      }
      if (mode == "newest") {
        obj.params = {
          page: page,
          tag_id: this.$route.params.tag_id,
          type_id: "0",
          label_id: 0
        };
      }
      if (mode == "hot") {
        obj.params = {
          page: page,
          tag_id: this.$route.params.tag_id,
          type_id: "1",
          label_id: 0
        };
      }
      if (mode == "label") {
        obj.params = {
          page: page,
          tag_id: this.$route.params.tag_id,
          type_id: "3",
          label_id: this.lid || 2
        };
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__untils_until_js__["a" /* getParam */])("from") != null) {
        obj.params.from = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__untils_until_js__["a" /* getParam */])("from");
      }
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__untils_until_js__["a" /* getParam */])("isappinstalled") != null) {
        obj.params.isappinstalled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__untils_until_js__["a" /* getParam */])("isappinstalled");
      }
      reqData = { data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj) };

      self.ifShowBottomLoading = true;
      self.axios.post(api, qs.stringify(reqData), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(function (res) {
        var resBody = res.data;
        if (resBody.ret == 0 && resBody.data.list.length) {
          _this2[mode + "Mode"] = resBody.data.show_style;
          _this2[mode + "Page"] += 1;
          _this2[mode + "List"] = page > 1 ? _this2.normalList = _this2[mode + "List"].concat(resBody.data.list) : resBody.data.list;

          if (resBody.data.show_style == 1 && first == true) {
            _this2.listMode = 1;
            var _self = _this2;
            __WEBPACK_IMPORTED_MODULE_7_vue__["default"].nextTick(function () {
              _self.tabsConfig.active = 1;
              _self.$refs.tabNav.changeTab(null, 1, false);
              _self.renderWaterFall(_self[mode + "List"]);
            });
          } else if (resBody.data.show_style == 1 && first == false) {
            _this2.renderWaterFall(self[mode + "List"]);
          }
        }
        self.ifShowBottomLoading = false;
      });
    },

    // 倒计时 endTimeStamp 毫秒
    countDown: function countDown(endTimeStamp) {
      endTimeStamp = parseInt(endTimeStamp);
      var nowTimestamp = Date.now();
      var leftTime = endTimeStamp - nowTimestamp;

      var data = {};

      if (leftTime > 0) {
        var d = Math.floor(leftTime / 1000 / 24 / 60 / 60);
        var h = Math.floor(leftTime / 1000 / 60 / 60 % 24);
        var m = Math.floor(leftTime / 1000 / 60 % 60);
        var s = Math.floor(leftTime / 1000 % 60);
        data = {
          d: d,
          h: h,
          m: m,
          s: s,
          isEnd: false
        };
      } else {
        data = {
          d: 0,
          h: 0,
          m: 0,
          s: 0,
          isEnd: true
        };
      }

      return data;
    },

    // 点赞
    onZan: function onZan(index) {
      var _this3 = this;

      if (!globalData.isLogin) {
        window.location.href = "http://my2.xizi.com/user/social-login?type=wx&referrer=" + encodeURIComponent(location.href);
        return;
      }
      var self = this;
      var api = "/index.php?r=web/ajaxpraise&v=4.2.0";
      var preZanState = this[this.currentKey + "List"][index].is_praise;
      var reqData = {
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
          params: {
            id: this[this.currentKey + "List"][index].id,
            qx: preZanState // 0 点赞 1取消点赞
          }
        })
      };
      self[this.currentKey + "List"][index].is_praise = preZanState == 0 ? 1 : 0;
      self.axios.post(api, qs.stringify(reqData), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(function (response) {
        var resBody = response.data;
        console.log(resBody);
        if (resBody.ret !== 0) {
          self[_this3.currentKey + "List"][index].is_praise = preZanState;
        }
        self.normalList = self[_this3.currentKey + "List"];
      }).catch(function () {
        self[_this3.currentKey + "List"][index].is_praise = preZanState;
        self.normalList = self[_this3.currentKey + "List"];
      });
      self.normalList = self[this.currentKey + "List"];
    },
    jumpLocation: function jumpLocation(x, y) {
      // wx.openLocation({
      //     latitude: y, // 纬度，浮点数，范围为90 ~ -90
      //     longitude: x, // 经度，浮点数，范围为180 ~ -180。
      //     name: '', // 位置名
      //     address: '', // 地址详情说明
      //     scale: 1, // 地图缩放级别,整形值,范围从1~28。默认为最大
      //     infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
      // });
    },
    openAppTopic: function openAppTopic() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__untils_until_js__["b" /* magicLink */])('po_tag', window.OS === 'ios' ? 'tag_id=' + this.$route.params.tag_id : 'id=' + this.$route.params.tag_id);
    },
    formatSticker: function formatSticker() {
      var potxt = document.getElementsByClassName("po_txt");

      var commentTxt = document.getElementsByClassName("comment_list");

      var waterFallContent = document.getElementsByClassName("desc");

      if (potxt.length) {
        var txtFontSize = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(window.getComputedStyle(potxt[0], null).fontSize.split("px")[0]);
        this.forCircle(potxt, txtFontSize);
      }
      if (commentTxt.length) {
        var commentFontSize = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(window.getComputedStyle(commentTxt[0], null).fontSize.split("px")[0]);
        this.forCircle(commentTxt, commentFontSize);
      }
      if (waterFallContent.length) {
        var waterFallFontSize = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(window.getComputedStyle(waterFallContent[0], null).fontSize.split("px")[0]);
        this.forCircle(waterFallContent, waterFallFontSize);
      }
    },
    forCircle: function forCircle(item, fontSize) {
      for (var i = 0, length = item.length; i < length; i++) {
        var img = item[i].querySelectorAll("img");
        if (img.length) {
          for (var j = 0, _length = img.length; j < _length; j++) {
            img[j].style.width = fontSize + "px";
            img[j].style.height = fontSize + "px";
          }
        }
      }
    },
    toLabel: function toLabel(id) {
      this.$router.push("/tag-list/" + id);
      console.info(id);
    }
  },
  created: function created() {
    var _this4 = this;

    // //加载首屏数据
    var api = "/index.php?r=web/posttaglist&v=4.7.0";
    var self = this;
    var obj = {
      params: {
        page: 1,
        tag_info: "1",
        tag_id: self.$route.params.tag_id
      }
    };
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__untils_until_js__["a" /* getParam */])("from") != null) {
      obj.params.from = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__untils_until_js__["a" /* getParam */])("from");
    }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__untils_until_js__["a" /* getParam */])("isappinstalled") != null) {
      obj.params.isappinstalled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__untils_until_js__["a" /* getParam */])("isappinstalled");
    }
    var reqData = {
      data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj)
    };
    this.axios.post(api, qs.stringify(reqData), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    }).then(function (response) {
      var resBody = response.data;
      if (resBody.ret == 0) {
        self.showCutscenes = false;
        wx.ready(function () {
          wx.onMenuShareTimeline({
            title: resBody.data.tag.share.share_title,
            link: resBody.data.tag.share.share_url,
            imgUrl: resBody.data.tag.share_image_url
          });
          wx.onMenuShareAppMessage({
            title: resBody.data.tag.share.share_title,
            desc: "惠州生活必备-西子湖畔App",
            link: resBody.data.tag.share.share_url,
            imgUrl: resBody.data.tag.share.share_image_url
          });
        });
        // 活动倒计时
        if (resBody.data.tag.if_prize == 2) {
          _this4.prizes = resBody.data.tag.prize_info.prizes;
          var endAt = parseInt(resBody.data.tag.prize_info.end_at);
          var timer = setInterval(function () {
            var leftTime = self.countDown(endAt);
            self.activityEndTime = leftTime;
            if (endAt <= 0) {
              clearInterval(timer);
            }
          }, 1000);
        }
        // 设置话题模式
        _this4.topicMode = resBody.data.tag.if_prize;

        if (_this4.topicMode == 0) {
          // 普通话题
          _this4.tabsConfig.tabs = ["最新", "热门"];

          if (resBody.data.tag.labels.length) {
            _this4.tabsConfig.tabs.push("标签");
            _this4.labels = resBody.data.tag.labels;
            _this4.loadPoListData("label", 1);
          }
          _this4.listMode = _this4.newestMode = resBody.data.show_style;
          _this4.newestPage++;
          _this4.newestList = resBody.data.list;
          if (resBody.data.show_style == 1) {
            _this4.renderWaterFall(resBody.data.list);
            _this4.curTabType = "newestList";
          } else {
            _this4.normalList = resBody.data.list;
          }
          _this4.currentKey = "newest";

          _this4.loadPoListData("hot", 1, true);
        } else {
          if (resBody.data.tag.labels.length) {
            _this4.tabsConfig.tabs.push("标签");
            _this4.labels = resBody.data.tag.labels;
            _this4.loadPoListData("label", 1);
          }
          // 高级话题
          _this4.tabsConfig.tabs = ["排行", "最新"];
          _this4.tabsConfig.active = 0;
          _this4.rankPage++;
          _this4.listMode = _this4.rankMode = resBody.data.show_style;
          _this4.rankList = resBody.data.list;

          if (resBody.data.show_style == 1) {
            _this4.renderWaterFall(resBody.data.list);
          } else {
            _this4.normalList = resBody.data.list;
          }
          _this4.currentKey = "rank";

          // 加载最新数据
          _this4.loadPoListData("newest", 1);
        }
        _this4.tag_info = resBody.data.tag;
        _this4.activity = resBody.data.activity;
      }
    });
  },
  mounted: function mounted() {
    var self = this;
    document.title = "话题";
    var oNav = document.querySelector(".download_nav");
    var h = oNav.offsetHeight;
    window.addEventListener("scroll", function (e) {
      var sTop = document.documentElement.scrollTop || document.body.scrollTop;
      var docH = document.documentElement.scrollHeight || document.body.scrollHeight;
      var winH = document.documentElement.clientHeight || document.body.clientHeight;
      if (sTop == docH - winH) {
        switch (self.tabsConfig.tabs[self.tabsConfig.active]) {
          case "排行":
            self.loadPoListData("rank", self.rankPage);
            self.currentKey = "rank";
            break;
          case "最新":
            self.loadPoListData("newest", self.newestPage);
            self.currentKey = "newest";
            break;
          case "热门":
            self.loadPoListData("hot", self.hotPage);
            self.currentKey = "hot";
            break;
          case "标签":
            self.loadPoListData("label", self.labelPage);
            self.currentKey = "hot";
            break;
          default:
            break;
        }
      }
      if (sTop > h) {
        self.ifShow = true;
      } else {
        self.ifShow = false;
      }
    });
    // this.wxConfig();
  },
  updated: function updated() {
    this.formatSticker();
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_download_tab_DownloadNav_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_download_tab_DownloadNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_download_tab_DownloadNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tab_nav_TabNav_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tab_nav_TabNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_tab_nav_TabNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_bottom_loading_BottomLoading_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_bottom_loading_BottomLoading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_bottom_loading_BottomLoading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pic_box_PicBox_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pic_box_PicBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pic_box_PicBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_cutscenes_Cutscenes_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_cutscenes_Cutscenes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_cutscenes_Cutscenes_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_qs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__untils_until_js__ = __webpack_require__(4);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  data: function data() {
    return {
      showCutscenes: true,
      tabsConfig: {
        tabs: [],
        active: 1
      },
      // 当前选项卡选中的类型
      curTabType: "",
      loading: false,
      topicMode: 0, // 0普通话题 其他高级话题
      listMode: 1, // 0普通模式 1瀑布流模式
      ifShowBottomLoading: false,
      allData: null,
      hotData: null,
      activity: null,
      tag_info: null,
      t: null,
      // 普通列表要展示的数据
      normalList: [],
      // 瀑布流列表要展示的数据
      waterFall: {
        col_0: [],
        col_1: [],
        // 高度较短的列的索引
        short: 0
      },
      openMap: false,
      // 最新
      newestList: [],
      newPage: 1,
      // 热门
      hotList: [],
      hotPage: 1,
      // 排行榜
      rankList: [],
      rankPage: 1,
      noMoreData: false,
      loaded: false,
      label_info: {},
      map: null,
      page: 1,
      ifShow: false
    };
  },


  components: {
    DownloadNav: __WEBPACK_IMPORTED_MODULE_2__components_download_tab_DownloadNav_vue___default.a,
    TabNav: __WEBPACK_IMPORTED_MODULE_3__components_tab_nav_TabNav_vue___default.a,
    BottomLoading: __WEBPACK_IMPORTED_MODULE_4__components_bottom_loading_BottomLoading_vue___default.a,
    PicBox: __WEBPACK_IMPORTED_MODULE_5__components_pic_box_PicBox_vue___default.a,
    Cutscenes: __WEBPACK_IMPORTED_MODULE_6__components_cutscenes_Cutscenes_vue___default.a
  },
  methods: {
    toMap: function toMap(lat, log) {
      window.location = "/webpo.php?map=1&lat=" + lat + "&log=" + log + "&title=" + this.label_info.label_name;
    },


    // 渲染瀑布流
    renderWaterFall: function renderWaterFall(data) {
      var self = this;
      self.waterFall = {
        col_0: [],
        col_1: [],
        short: 0
      };

      if (!data.length) {
        return;
      }
      var index = 0;
      var len = data.length;
      var w = self.$refs.col_0.offsetWidth;
      calcWaterFall(data);
      function calcWaterFall(data) {
        var imgRatio = data[index].cover.h / data[index].cover.w;
        var imgW = w;
        var imgH = w * imgRatio;
        var item = data[index];
        item.cover.w = imgW;
        item.cover.h = imgH;
        self.waterFall["col_" + self.waterFall.short].push(item);
        __WEBPACK_IMPORTED_MODULE_7_vue__["default"].nextTick(function () {
          var h0 = self.$refs.col_0.offsetHeight;
          var h1 = self.$refs.col_1.offsetHeight;
          self.waterFall.short = h0 <= h1 ? 0 : 1;
          index++;
          if (index >= data.length) {
            return;
          }
          calcWaterFall(data);
        });
      }
    },

    // 跳转详情页
    jumpPoDetail: function jumpPoDetail(po_id) {
      this.$router.push("/newDetail/" + po_id);
    },
    openAppTopic: function openAppTopic() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__untils_until_js__["b" /* magicLink */])('po_tag', 'tag_id=' + this.$route.params.tag_id);
    },
    formatSticker: function formatSticker() {
      var potxt = document.getElementsByClassName("po_txt");

      var commentTxt = document.getElementsByClassName("comment_list");

      var waterFallContent = document.getElementsByClassName("desc");

      if (potxt.length) {
        var txtFontSize = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(window.getComputedStyle(potxt[0], null).fontSize.split("px")[0]);
        this.forCircle(potxt, txtFontSize);
      }
      if (commentTxt.length) {
        var commentFontSize = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(window.getComputedStyle(commentTxt[0], null).fontSize.split("px")[0]);
        this.forCircle(commentTxt, commentFontSize);
      }
      if (waterFallContent.length) {
        var waterFallFontSize = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(window.getComputedStyle(waterFallContent[0], null).fontSize.split("px")[0]);
        this.forCircle(waterFallContent, waterFallFontSize);
      }
    },
    forCircle: function forCircle(item, fontSize) {
      for (var i = 0, length = item.length; i < length; i++) {
        var img = item[i].querySelectorAll("img");
        if (img.length) {
          for (var j = 0, _length = img.length; j < _length; j++) {
            img[j].style.width = fontSize + "px";
            img[j].style.height = fontSize + "px";
          }
        }
      }
    },
    getData: function getData() {
      var _this = this;

      var api = "/index.php?r=web/labelinfo&v=4.7.0";
      var self = this;
      var obj = {
        params: {
          page: this.page || 1,
          label_id: this.$route.params.tid
        }
      };
      if (this.$route.query.from) {
        obj.params.from = this.$route.query.from;
      }
      if (this.$route.query.isappinstalled) {
        obj.params.isappinstalled = this.$route.query.isappinstalled;
      }
      var reqData = {
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj)
      };
      if (this.loading == true) {
        return;
      }
      this.loading = true;
      this.axios.post(api, __WEBPACK_IMPORTED_MODULE_8_qs___default.a.stringify(reqData), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(function (response) {
        var resBody = response.data;
        if (resBody.ret == 0) {
          wx.ready(function () {
            wx.onMenuShareTimeline({
              title: resBody.data.label_info.share.share_title,
              link: resBody.data.label_info.share.share_url,
              imgUrl: resBody.data.label_info.share.share_image_url
            });
            wx.onMenuShareAppMessage({
              title: resBody.data.label_info.share.share_title,
              desc: "惠州生活必备-西子湖畔App",
              link: resBody.data.label_info.share.share_url,
              imgUrl: resBody.data.label_info.share.share_image_url
            });
          });
          _this.showCutscenes = false;
          _this.label_info = resBody.data.label_info;

          // 普通话题
          if (resBody.data.list.length > 0) {
            _this.page = _this.page + 1;
          }
          _this.normalList = resBody.data.list;
          _this.loading = false;
          // 渲染最热数据
          _this.renderWaterFall(resBody.data.list);
        }
      });
    },
    getMoreData: function getMoreData(page, cb) {
      var _this2 = this;

      var api = "/index.php?r=web/labelinfo&v=4.7.0";
      var self = this;
      var obj = {
        params: {
          page: page || 1,
          label_id: this.$route.params.tid
        }
      };
      if (this.$route.query.from) {
        obj.params.from = this.$route.query.from;
      }
      if (this.$route.query.isappinstalled) {
        obj.params.isappinstalled = this.$route.query.isappinstalled;
      }
      var reqData = {
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj)
      };
      if (this.loading == true) {
        return;
      }
      this.loading = true;
      this.axios.post(api, __WEBPACK_IMPORTED_MODULE_8_qs___default.a.stringify(reqData), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(function (response) {
        var resBody = response.data;
        if (resBody.ret == 0) {
          cb && cb(resBody.data.list);
          _this2.loading = false;
        }
      });
    }
  },
  created: function created() {
    // //加载首屏数据
    this.getData();
  },
  mounted: function mounted() {
    var self = this;
    document.title = "标签";
    var oNav = document.querySelector(".download_nav");
    var h = oNav.offsetHeight;
    window.addEventListener("scroll", function (e) {
      var sTop = document.documentElement.scrollTop || document.body.scrollTop;
      var docH = document.documentElement.scrollHeight || document.body.scrollHeight;
      var winH = document.documentElement.clientHeight || document.body.clientHeight;
      if (sTop == docH - winH && !self.loading) {
        self.getMoreData(self.page += 1, function (data) {
          if (data.length) {
            self.normalList = self.normalList.concat(data);
            self.renderWaterFall(self.normalList);
          }
        });
      }
      if (sTop > h) {
        self.ifShow = true;
      } else {
        self.ifShow = false;
      }
    });
  },
  updated: function updated() {
    this.formatSticker();
  }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_download_nav_DownloadNav_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_download_nav_DownloadNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_download_nav_DownloadNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tab_nav_TabNav_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tab_nav_TabNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_tab_nav_TabNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_bottom_loading_BottomLoading_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_bottom_loading_BottomLoading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_bottom_loading_BottomLoading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pic_box_PicBox_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pic_box_PicBox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pic_box_PicBox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_cutscenes_Cutscenes_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_cutscenes_Cutscenes_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_cutscenes_Cutscenes_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__untils_until_js__ = __webpack_require__(4);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var qs = __webpack_require__(3);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  data: function data() {
    return {
      showCutscenes: true,
      tabsConfig: {
        tabs: [],
        active: 1
      },
      // 当前选项卡选中的类型
      curTabType: "",

      topicMode: 0, // 0普通话题 其他高级话题
      listMode: 1, // 0普通模式 1瀑布流模式
      ifShowBottomLoading: false,
      allData: null,
      hotData: null,
      activity: null,
      tag_info: null,
      t: null,
      // 普通列表要展示的数据
      normalList: [],
      // 瀑布流列表要展示的数据
      waterFall: {
        col_0: [],
        col_1: [],
        // 高度较短的列的索引
        short: 0
      },

      // 最新
      newestList: [],
      newPage: 1,
      // 热门
      hotList: [],
      hotPage: 1,
      // 排行榜
      rankList: [],
      rankPage: 1,

      // 活动倒计时对象
      activityEndTime: null
    };
  },

  components: {
    DownloadNav: __WEBPACK_IMPORTED_MODULE_2__components_download_nav_DownloadNav_vue___default.a,
    TabNav: __WEBPACK_IMPORTED_MODULE_3__components_tab_nav_TabNav_vue___default.a,
    BottomLoading: __WEBPACK_IMPORTED_MODULE_4__components_bottom_loading_BottomLoading_vue___default.a,
    PicBox: __WEBPACK_IMPORTED_MODULE_5__components_pic_box_PicBox_vue___default.a,
    Cutscenes: __WEBPACK_IMPORTED_MODULE_6__components_cutscenes_Cutscenes_vue___default.a
  },
  methods: {
    // 切换选项卡回调
    tabChanged: function tabChanged(index) {
      var self = this;
      self.tabsConfig.active = parseInt(index);
      if (self.topicMode == 0) {
        // 普通话题
        if (index == 0) {
          // 最新
          self.listMode = 0;
          self.normalList = self.newestList;
          self.curTabType = "newestList";
        } else if (index == 1) {
          // 热门
          self.listMode = 1;
          self.curTabType = "hotList";
          __WEBPACK_IMPORTED_MODULE_7_vue__["default"].nextTick(function () {
            self.renderWaterFall(self.hotList);
          });
        }
      } else {
        // 高级话题
        if (index == 0) {
          // 排行榜
          self.listMode = 0;
          self.normalList = self.rankList;
          self.curTabType = "rankList";
        } else if (index == 1) {
          // 最新
          self.listMode = 0;
          self.normalList = self.newestList;
          self.curTabType = "newestList";
        }
      }
    },

    // 渲染瀑布流
    renderWaterFall: function renderWaterFall(data) {
      var self = this;

      self.waterFall = {
        col_0: [],
        col_1: [],
        short: 0
      };

      if (!data.length) {
        return;
      }
      var index = 0;
      var len = data.length;
      var w = self.$refs.col_0.offsetWidth;
      calcWaterFall(data);
      function calcWaterFall(data) {
        var imgRatio = data[index].images[0].h / data[index].images[0].w;
        var imgW = w;
        var imgH = w * imgRatio;
        var item = data[index];
        item.images[0].w = imgW;
        item.images[0].h = imgH;

        self.waterFall["col_" + self.waterFall.short].push(item);
        __WEBPACK_IMPORTED_MODULE_7_vue__["default"].nextTick(function () {
          var h0 = self.$refs.col_0.offsetHeight;
          var h1 = self.$refs.col_1.offsetHeight;
          self.waterFall.short = h0 <= h1 ? 0 : 1;
          index++;
          if (index >= data.length) {
            return;
          }
          calcWaterFall(data);
        });
      }
    },

    // 跳转详情页
    jumpPoDetail: function jumpPoDetail(po_id) {
      this.$router.push("/detail/" + po_id);
    },

    // 加载po列表数据
    loadPoListData: function loadPoListData(mode, page, cb) {
      var self = this;
      var api = "/index.php?r=web/ajaxposttaglist&v=4.2.0";
      var reqData = {};
      var obj = {
        params: {}
      };
      switch (mode) {
        case "rank":
          // reqData = {
          //   data: JSON.stringify({
          //     params: {
          //       page: page,
          //       tag_info: "1",
          //       type_id: "2",
          //       tag_id: self.$route.params.tag_id
          //     }
          //   })
          // };
          obj.params = {
            page: page,
            tag_info: "1",
            type_id: "2",
            tag_id: self.$route.params.tag_id
          };
          break;
        case "new":
          obj.params = {
            page: page,
            tag_info: "1",
            type_id: "0",
            tag_id: self.$route.params.tag_id
          };
          // reqData = {
          //   data: JSON.stringify({
          //     params: {
          //       page: page,
          //       tag_info: "1",
          //       type_id: "0",
          //       tag_id: self.$route.params.tag_id
          //     }
          //   })
          // };
          break;
        case "hot":
          obj.params = {
            page: page,
            tag_info: "1",
            type_id: "1",
            tag_id: self.$route.params.tag_id
          };
          // reqData = {
          //   data: JSON.stringify({
          //     params: {
          //       page: page,
          //       tag_info: "1",
          //       type_id: "1",
          //       tag_id: self.$route.params.tag_id
          //     }
          //   })
          // };
          break;
        default:
          break;
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__untils_until_js__["a" /* getParam */])("from") != null) {
        obj.params.from = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__untils_until_js__["a" /* getParam */])("from");
      }
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__untils_until_js__["a" /* getParam */])("isappinstalled") != null) {
        obj.params.isappinstalled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__untils_until_js__["a" /* getParam */])("isappinstalled");
      }
      reqData = { data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj) };
      if (self.ifShowBottomLoading) {
        return;
      }
      self.ifShowBottomLoading = true;
      self.axios.post(api, qs.stringify(reqData), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(function (res) {
        var resBody = res.data;
        if (resBody.ret == 0) {
          cb && cb(resBody.data.threads);
        }
        self.ifShowBottomLoading = false;
      });
    },

    // 倒计时 endTimeStamp 毫秒
    countDown: function countDown(endTimeStamp) {
      endTimeStamp = parseInt(endTimeStamp);
      var nowTimestamp = Date.now();
      var leftTime = endTimeStamp - nowTimestamp;

      var data = {};

      if (leftTime > 0) {
        var d = Math.floor(leftTime / 1000 / 24 / 60 / 60);
        var h = Math.floor(leftTime / 1000 / 60 / 60 % 24);
        var m = Math.floor(leftTime / 1000 / 60 % 60);
        var s = Math.floor(leftTime / 1000 % 60);
        data = {
          d: d,
          h: h,
          m: m,
          s: s,
          isEnd: false
        };
      } else {
        data = {
          d: 0,
          h: 0,
          m: 0,
          s: 0,
          isEnd: true
        };
      }

      return data;
    },

    // 点赞
    onZan: function onZan(index) {
      if (!globalData.isLogin) {
        window.location.href = "http://my2.xizi.com/user/social-login?type=wx&referrer=" + encodeURIComponent(location.href);
        return;
      }
      var self = this;
      var api = "/index.php?r=web/ajaxpraise&v=4.2.0";
      var preZanState = self[self.curTabType][index].is_praise;
      var reqData = {
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
          params: {
            id: self[self.curTabType][index].id,
            qx: preZanState // 0 点赞 1取消点赞
          }
        })
      };
      self[self.curTabType][index].is_praise = preZanState == 0 ? 1 : 0;
      self.axios.post(api, qs.stringify(reqData), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(function (response) {
        var resBody = response.data;
        console.log(resBody);
        if (resBody.ret !== 0) {
          self[self.curTabType][index].is_praise = preZanState;
        }
        self.normalList = self[self.curTabType];
      }).catch(function () {
        self[self.curTabType][index].is_praise = preZanState;
        self.normalList = self[self.curTabType];
      });
      self.normalList = self[self.curTabType];
    },
    jumpLocation: function jumpLocation(x, y) {
      // wx.openLocation({
      //     latitude: y, // 纬度，浮点数，范围为90 ~ -90
      //     longitude: x, // 经度，浮点数，范围为180 ~ -180。
      //     name: '', // 位置名
      //     address: '', // 地址详情说明
      //     scale: 1, // 地图缩放级别,整形值,范围从1~28。默认为最大
      //     infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
      // });
    },
    openAppTopic: function openAppTopic() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__untils_until_js__["b" /* magicLink */])('po_tag', 'tag_id=' + this.$route.params.tag_id);
    },
    formatSticker: function formatSticker() {
      var potxt = document.getElementsByClassName("po_txt");

      var commentTxt = document.getElementsByClassName("comment_list");

      var waterFallContent = document.getElementsByClassName("desc");

      if (potxt.length) {
        var txtFontSize = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(window.getComputedStyle(potxt[0], null).fontSize.split("px")[0]);
        this.forCircle(potxt, txtFontSize);
      }
      if (commentTxt.length) {
        var commentFontSize = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(window.getComputedStyle(commentTxt[0], null).fontSize.split("px")[0]);
        this.forCircle(commentTxt, commentFontSize);
      }
      if (waterFallContent.length) {
        var waterFallFontSize = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(window.getComputedStyle(waterFallContent[0], null).fontSize.split("px")[0]);
        this.forCircle(waterFallContent, waterFallFontSize);
      }
    },
    forCircle: function forCircle(item, fontSize) {
      for (var i = 0, length = item.length; i < length; i++) {
        var img = item[i].querySelectorAll("img");
        if (img.length) {
          for (var j = 0, _length = img.length; j < _length; j++) {
            img[j].style.width = fontSize + "px";
            img[j].style.height = fontSize + "px";
          }
        }
      }
    }
  },
  created: function created() {
    var _this = this;

    // //加载首屏数据
    var api = "/index.php?r=web/ajaxposttaglist&v=4.2.0";
    var self = this;
    var obj = {
      params: {
        page: 1,
        tag_info: "1",
        type_id: "1",
        tag_id: self.$route.params.tag_id
      }
    };
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__untils_until_js__["a" /* getParam */])("from") != null) {
      obj.params.from = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__untils_until_js__["a" /* getParam */])("from");
    }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__untils_until_js__["a" /* getParam */])("isappinstalled") != null) {
      obj.params.isappinstalled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__untils_until_js__["a" /* getParam */])("isappinstalled");
    }
    var reqData = {
      data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj)
    };
    this.axios.post(api, qs.stringify(reqData), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    }).then(function (response) {
      console.log(response.data);
      var resBody = response.data;
      if (resBody.ret == 0) {
        self.allData = resBody.data;
        self.showCutscenes = false;
        //配置微信分享
        // window.setShareConfig({
        // title: resBody.data.tag_info.share_title,
        // desc: "惠州生活必备-西子湖畔App",
        // link: resBody.data.tag_info.share_url,
        // imgUrl: resBody.data.tag_info.share_image_url
        // });
        wx.ready(function () {
          wx.onMenuShareTimeline({
            title: resBody.data.tag_info.share_title,
            link: resBody.data.tag_info.share_url,
            imgUrl: resBody.data.tag_info.share_image_url
          });
          wx.onMenuShareAppMessage({
            title: resBody.data.tag_info.share_title,
            desc: "惠州生活必备-西子湖畔App",
            link: resBody.data.tag_info.share_url,
            imgUrl: resBody.data.tag_info.share_image_url
          });
        });
        // 活动倒计时
        if (resBody.data.tag_info) {
          var endAt = parseInt(resBody.data.tag_info.end_at);
          var timer = setInterval(function () {
            var leftTime = self.countDown(endAt);
            self.activityEndTime = leftTime;
            if (endAt <= 0) {
              clearInterval(timer);
            }
          }, 1000);
        }
        // 设置话题模式
        _this.topicMode = resBody.data.tag_info.if_prize;
        if (_this.topicMode == 0) {
          // 普通话题
          _this.tabsConfig.tabs = ["最新", "热门"];
          _this.hotList = resBody.data.threads;

          // 渲染最热数据
          _this.normalList = _this.hotList;
          _this.curTabType = "hotList";
          _this.renderWaterFall(_this.hotList);
          // 预加载最新数据
          _this.loadPoListData("new", 1, function (data) {
            _this.newestList = data;
          });
        } else {
          // 高级话题
          _this.tabsConfig.tabs = ["排行榜", "最新"];
          _this.tabsConfig.active = 0;
          _this.listMode = 0;
          // 加载排行榜数据
          _this.loadPoListData("rank", 1, function (data) {
            _this.rankList = data;
            // 渲染排行榜数据
            _this.normalList = _this.rankList;
            _this.curTabType = "rankList";
            // 保存最新数据
            _this.newestList = resBody.data.threads;
          });
        }
        _this.tag_info = resBody.data.tag_info;
        _this.activity = resBody.data.activity;
      }
    });
  },
  mounted: function mounted() {
    var self = this;
    document.title = "话题详情";
    window.addEventListener("scroll", function (e) {
      var sTop = document.documentElement.scrollTop || document.body.scrollTop;
      var docH = document.documentElement.scrollHeight || document.body.scrollHeight;
      var winH = document.documentElement.clientHeight || document.body.clientHeight;
      if (sTop == docH - winH) {
        switch (self.tabsConfig.tabs[self.tabsConfig.active]) {
          case "排行榜":
            self.loadPoListData("rank", self.rankPage + 1, function (data) {
              if (data.length) {
                self.rankPage++;
                self.rankList = self.rankList.concat(data);
                self.normalList = self.rankList;
              }
            });
            break;
          case "最新":
            self.loadPoListData("new", self.newPage + 1, function (data) {
              if (data.length) {
                self.newPage++;
                self.newestList = self.newestList.concat(data);
                self.normalList = self.newestList;
              }
            });
            break;
          case "热门":
            self.loadPoListData("hot", self.hotPage + 1, function (data) {
              if (data.length) {
                self.hotPage++;
                self.hotList = self.hotList.concat(data);
                self.renderWaterFall(self.hotList);
              }
            });
            break;
          default:
            break;
        }
      }
    });
    // this.wxConfig();
  },
  updated: function updated() {
    this.formatSticker();
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__webpack_require__(35);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.wx = wx;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.contentFilters = function (msg) {
  return msg.replace(/\n/ig, '<br />');
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);

var qs = __webpack_require__(3);

// 微信配置
// AjaxWxConfig
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post('/index.php?r=web/ajaxwxconfig&v=4.2.0', qs.stringify({}), {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
}).then(function (res) {
  var resBody = res.data;
  if (resBody.appId) {
    wx.config({
      debug: false,
      appId: resBody.appId,
      timestamp: resBody.timestamp,
      nonceStr: resBody.nonceStr,
      signature: resBody.signature,
      jsApiList: resBody.jsApiList
    });
  }
});

// window.setShareConfig = (opt) => {
//   console.info(opt)
//   wx.onMenuShareTimeline({
//     title: opt.title, // 分享标题
//     link: opt.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
//     imgUrl: opt.imgUrl // 分享图标
//   });
//   wx.onMenuShareAppMessage({
//     title: opt.title, // 分享标题
//     desc: opt.desc, // 分享描述
//     link: opt.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
//     imgUrl: opt.imgUrl // 分享图标
//   });
// }

// 判断登录
window.globalData = {
  isLogin: /Xz_auth/.test(document.cookie)
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],

  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 90 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(90)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(118),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a9dbf97",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(93)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(121),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-64d1555f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(88)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(116),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-491847f3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(96)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(124),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c53e36ce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(99)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(127),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ebb05dfa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(91)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(119),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ded73a2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(97)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(125),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c57b2bde",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(92)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(120),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5f9f7b9f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download_nav",
    class: _vm.ifShow ? 'show' : 'hide'
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "tip"
  }, [_vm._v("来 在惠州 晒一张")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    on: {
      "click": _vm.openApp
    }
  }, [_vm._v("立即打开")])])])
},staticRenderFns: []}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab_nav"
  }, [_vm._l((_vm.tabs), function(item, index) {
    return [_c('div', {
      ref: 'tab_' + index,
      refInFor: true,
      class: 'tab_item ' + (index == _vm.active ? 'on' : ''),
      attrs: {
        "data-index": index
      },
      on: {
        "click": _vm.changeTab
      }
    }, [_vm._v("\n            " + _vm._s(item) + "\n        ")])]
  }), _vm._v(" "), _c('div', {
    ref: "line",
    staticClass: "line",
    style: ('transform:translateX(' + _vm.lineLeft + 'px)')
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'detail'
  }, [(_vm.showCutscenes) ? _c('Cutscenes') : _vm._e(), _vm._v(" "), _c('DownloadNav', {
    attrs: {
      "ifShow": _vm.ifShow
    }
  }), _vm._v(" "), _c('div', {
    class: 'detail-content'
  }, [(_vm.poData && _vm.poData.images.length && !_vm.isVideo) ? _c('div', {
    staticClass: "swipe-box"
  }, [_c('Swipe', {
    staticClass: "swipe-content",
    attrs: {
      "showIndicators": false,
      "auto": 0,
      "continuous": false
    },
    on: {
      "change": _vm.handleChange
    }
  }, _vm._l((_vm.poData.images), function(item, index) {
    return _c('SwipeItem', {
      key: item.url,
      attrs: {
        "alt": index
      }
    }, [_c('div', {
      staticClass: "carouse-item",
      style: (("background-image:url(" + (item.hd_url) + ")"))
    })])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "post-info-bottom"
  }, [_c('div', {
    staticClass: "post-info-left"
  }, [_c('div', {
    staticClass: "likers"
  }, _vm._l((_vm.poData.praise), function(item, index) {
    return (index < 3) ? _c('img', {
      key: index,
      staticClass: "likers-avatar",
      attrs: {
        "src": item.face,
        "alt": "",
        "srcset": ""
      }
    }) : _vm._e()
  }), 0), _vm._v(" "), (parseInt(_vm.poData.praise_count) != 0) ? _c('span', [_vm._v(_vm._s(_vm.poData.praise_count) + "赞")]) : _vm._e(), _vm._v(" "), (parseInt(_vm.poData.collect_count) != 0) ? _c('span', [_vm._v(_vm._s(_vm.poData.collect_count) + "收藏")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "post-info-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.poData.views) + "阅读")])])]), _vm._v(" "), (_vm.poData.images.length > 1) ? _c('span', {
    staticClass: "indicators"
  }, [_vm._v("\n          " + _vm._s(_vm.poData.images.length > 1 ? _vm.swipeIndex + 1 : 1) + "/" + _vm._s(_vm.poData.images.length) + "\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.poData && _vm.isVideo) ? _c('div', {
    class: 'video ' + (_vm.playing ? 'full' : '')
  }, [_c('video', {
    ref: "video",
    attrs: {
      "webkit-playsinline": "",
      "playsinline": "",
      "x5-playsinline": "",
      "x-webkit-airplay": "allow",
      "poster": _vm.poData.images[0].url,
      "src": _vm.poData.images[1].url
    },
    on: {
      "click": _vm.playVideo,
      "ended": _vm.ended
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "video-btn",
    attrs: {
      "hidden": _vm.playing
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.playVideo($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "post-info-bottom"
  }, [_c('div', {
    staticClass: "post-info-left"
  }, [_c('div', {
    staticClass: "likers"
  }, _vm._l((_vm.poData.praise), function(item, index) {
    return (index < 3) ? _c('img', {
      key: index,
      staticClass: "likers-avatar",
      attrs: {
        "src": item.face,
        "alt": "",
        "srcset": ""
      }
    }) : _vm._e()
  }), 0), _vm._v(" "), _c('span', [_vm._v(_vm._s(parseInt(_vm.poData.praise_count)) + "赞")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(parseInt(_vm.poData.collect_count)) + "收藏")])]), _vm._v(" "), _c('div', {
    staticClass: "post-info-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.poData.views) + "阅读")])])])]) : _vm._e(), _vm._v(" "), (_vm.poData) ? _c('div', {
    staticClass: "post-info"
  }, [_c('div', {
    staticClass: "post-user"
  }, [_c('div', {
    staticClass: "post-user-left"
  }, [_c('img', {
    staticClass: "user-avatar",
    attrs: {
      "src": _vm.poData.user.face,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    class: 'user-nickname ' + 'sex_' + _vm.poData.user.gender
  }, [_vm._v(_vm._s(_vm.poData.user.username))]), _vm._v(" "), _c('span', {
    staticClass: "user-po-time"
  }, [_vm._v(_vm._s(_vm._f("timestamp2txt")(_vm.poData.dateline)))])]), _vm._v(" "), _c('div', {
    staticClass: "post-identity"
  }, [_vm._l((_vm.poData.user.icons), function(item, index) {
    return _c('img', {
      key: index,
      staticClass: "post-medal",
      attrs: {
        "src": item,
        "alt": ""
      }
    })
  }), _vm._v(" "), _vm._l((_vm.poData.user.medals), function(item, index) {
    return _c('img', {
      key: item.medal_id,
      staticClass: "post-medal",
      attrs: {
        "src": item.medal_icon,
        "alt": index
      }
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "post-user-right"
  }, [(_vm.poData.tag.tag_stick || _vm.poData.sticker) ? _c('img', {
    staticClass: "po-sticker",
    attrs: {
      "src": _vm.poData.tag.tag_stick || _vm.poData.sticker,
      "alt": ""
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "post-content"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.poData.tag && _vm.poData.tag.tag_id),
      expression: "poData.tag && poData.tag.tag_id"
    }],
    staticClass: "tag",
    on: {
      "click": function($event) {
        return _vm.toTag(_vm.poData.tag.tag_id)
      }
    }
  }, [_vm._v("#" + _vm._s(_vm.poData.tag.tag_name) + " ")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentFilters(_vm.poData.content))
    }
  })]), _vm._v(" "), (_vm.poData.labels.length != 0) ? _c('div', {
    staticClass: "post-tags"
  }, [_c('span', {
    staticClass: "tag-icon margin"
  }), _vm._v(" "), _vm._l((_vm.poData.labels), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "tag margin",
      on: {
        "click": function($event) {
          return _vm.toLabel(item.label_id)
        }
      }
    }, [_vm._v(_vm._s(item.label_name))])
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "lottery-content"
  }, [_c('p', {
    staticClass: "lottery-title"
  }, [_vm._v("Ta们赞了")]), _vm._v(" "), _c('div', {
    staticClass: "lottery-list"
  }, _vm._l((_vm.lotteries), function(item, index) {
    return _c('div', {
      staticClass: "list-item"
    }, [_c('span', {
      staticClass: "corner"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('img', {
      staticClass: "lottery-img",
      attrs: {
        "src": item.face,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "lottery-username"
    }, [_vm._v(_vm._s(item.username))])])
  }), 0)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "pic_container",
    staticClass: "pic_box"
  }, [(_vm.type == 1) ? [(_vm.images.length == 1) ? _c('div', {
    staticClass: "po_imgs pic_count_1"
  }, [_c('div', {
    staticClass: "pic_item",
    style: ('background-image:url(' + _vm.images[0].url + ');' + (_vm.images[0].w > _vm.deviceWidth ? 'width:' + _vm.deviceWidth + 'px;height:' + _vm.deviceWidth / (_vm.images[0].w / _vm.images[0].h) + 'px;' : '')),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onReadPoImg(0)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.images.length == 2) ? _c('div', {
    staticClass: "po_imgs pic_count_2"
  }, _vm._l((_vm.images), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pic_item",
      style: ('background-image:url(' + item.url + ')'),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onReadPoImg(index)
        }
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), (_vm.images.length == 3) ? _c('div', {
    staticClass: "po_imgs pic_count_3"
  }, _vm._l((_vm.images), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pic_item",
      style: ('background-image:url(' + item.url + ')'),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onReadPoImg(index)
        }
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), (_vm.images.length == 4) ? _c('div', {
    staticClass: "po_imgs pic_count_4"
  }, _vm._l((_vm.images), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pic_item",
      style: ('background-image:url(' + item.url + ')'),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onReadPoImg(index)
        }
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), (_vm.images.length == 5) ? _c('div', {
    staticClass: "po_imgs pic_count_5"
  }, _vm._l((_vm.images), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pic_item",
      class: index > 1 ? 'row_2' : '',
      style: ('background-image:url(' + item.url + ')'),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onReadPoImg(index)
        }
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), (_vm.images.length == 6) ? _c('div', {
    staticClass: "po_imgs pic_count_6"
  }, [_c('div', {
    staticClass: "row_1"
  }, [_c('div', {
    staticClass: "pic_1 pic_item",
    style: ('background-image:url(' + _vm.images[0].url + ')'),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onReadPoImg(_vm.index)
      }
    }
  }), _vm._v(" "), _c('div', _vm._l((_vm.images), function(item, index) {
    return (index > 0 && index < 3) ? _c('div', {
      key: index,
      staticClass: "pic_item",
      style: ('background-image:url(' + item.url + ')'),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onReadPoImg(index)
        }
      }
    }) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row_2"
  }, _vm._l((_vm.images), function(item, index) {
    return (index > 2) ? _c('div', {
      key: index,
      staticClass: "pic_item",
      style: ('background-image:url(' + item.url + ')'),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onReadPoImg(index)
        }
      }
    }) : _vm._e()
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.images.length == 7) ? _c('div', {
    staticClass: "po_imgs pic_count_7"
  }, _vm._l((_vm.images), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pic_item",
      class: index == 0 ? 'pic_1' : '',
      style: ('background-image:url(' + item.url + ')'),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onReadPoImg(index)
        }
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), (_vm.images.length == 8) ? _c('div', {
    staticClass: "po_imgs pic_count_8"
  }, _vm._l((_vm.images), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pic_item",
      class: index > 1 ? 'row_2' : '',
      style: ('background-image:url(' + item.url + ')'),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onReadPoImg(index)
        }
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), (_vm.images.length == 9) ? _c('div', {
    staticClass: "po_imgs pic_count_9"
  }, _vm._l((_vm.images), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pic_item",
      style: ('background-image:url(' + item.url + ')'),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onReadPoImg(index)
        }
      }
    })
  }), 0) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.type == 2) ? [(_vm.images.length) ? _c('div', {
    staticClass: "po_imgs pic_count_1"
  }, [_c('div', {
    staticClass: "pic_item video",
    style: ('background-image:url(' + _vm.images[0].url + ')'),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onOpenVideo(_vm.images[1].url)
      }
    }
  }, [_c('div', {
    staticClass: "play_btn"
  })])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.ifOpenVideo) ? _c('div', {
    staticClass: "video_wrap",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeVideo($event)
      }
    }
  }, [_c('video', {
    attrs: {
      "src": _vm.videoSrc,
      "controls": "controls"
    }
  })]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab_nav"
  }, [_vm._l((_vm.tabs), function(item, index) {
    return [_c('div', {
      ref: 'tab_' + index,
      refInFor: true,
      class: 'tab_item ' + (index == _vm.active ? 'on' : ''),
      attrs: {
        "data-index": index
      },
      on: {
        "click": function($event) {
          return _vm.changeTab($event, index)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item) + "\n        ")])]
  }), _vm._v(" "), _c('div', {
    ref: "line",
    staticClass: "line",
    style: ('transform:translateX(' + _vm.lineLeft + 'px)')
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topic"
    }
  }, [(_vm.showCutscenes) ? _c('Cutscenes') : _vm._e(), _vm._v(" "), _c('DownloadNav', {
    attrs: {
      "ifShow": _vm.ifShow
    }
  }), _vm._v(" "), (_vm.tag_info) ? [_c('img', {
    staticClass: "banner",
    attrs: {
      "src": _vm.tag_info.tag_img_square,
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top_pic"
  }, [(_vm.tag_info) ? _c('div', {
    class: ("topic_content " + (_vm.topicMode != 0 ? 'special' : 'normal'))
  }, [_c('div', {
    staticClass: "topic_name"
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tag_info.tag_name))])]), _vm._v(" "), (_vm.topicMode == 0) ? _c('p', {
    staticClass: "topic_detail"
  }, [_vm._v("\n          " + _vm._s(_vm.tag_info.tag_desc) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "topic_comments"
  }, [_vm._v("讨论 " + _vm._s(_vm.tag_info.thread_count))])]) : _vm._e()]), _vm._v(" "), (_vm.activity.tag_desc) ? _c('a', {
    staticClass: "topic_link",
    attrs: {
      "href": _vm.activity.url || 'javascript:;'
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v(_vm._s(_vm.activity.tag_desc))]), _vm._v(" "), _c('i', {
    staticClass: "arrow"
  })]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.topicMode != 0) ? _c('div', {
    staticClass: "prize-mode"
  }, [_c('div', {
    staticClass: "topic_desc"
  }, [_c('span', [_vm._v("\n        " + _vm._s(_vm.tag_info ? _vm.tag_info.tag_desc : '') + "\n      ")]), _vm._v(" "), _c('span', [(_vm.topicMode != 0) ? _c('a', {
    staticClass: "detail_btn",
    attrs: {
      "href": _vm.tag_info.prize_info ? _vm.tag_info.prize_info.url : ''
    }
  }, [_vm._v("查看详情>>>")]) : _vm._e()])]), _vm._v(" "), (_vm.tag_info && _vm.tag_info.end_at != 0 && _vm.activityEndTime) ? _c('div', {
    staticClass: "count-down"
  }, [_c('span', {
    staticClass: "line"
  }), _vm._v(" "), (!_vm.activityEndTime.isEnd) ? _c('span', {
    staticClass: "txt"
  }, [_vm._v("剩余时间：" + _vm._s(_vm.activityEndTime.d) + "天 " + _vm._s(_vm.activityEndTime.h) + "时 " + _vm._s(_vm.activityEndTime.m) + "分 " + _vm._s(_vm.activityEndTime.s) + "秒")]) : _c('span', {
    staticClass: "txt"
  }, [_vm._v("活动已结束")]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "jump-link"
  })]) : _vm._e(), _vm._v(" "), (_vm.tabsConfig.tabs.length) ? _c('tab-nav', {
    ref: "tabNav",
    attrs: {
      "tabs": _vm.tabsConfig.tabs,
      "active": _vm.tabsConfig.active
    },
    on: {
      "change": _vm.tabChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.labels.length) ? _c('div', {
    ref: "labelContainer",
    staticClass: "label-list"
  }, _vm._l((_vm.labels), function(item, index) {
    return _c('span', {
      key: ("label_" + index),
      class: ("label " + (index == _vm.currIndex ? 'active' : '')),
      attrs: {
        "data-index": index,
        "data-lid": item.label_id
      },
      on: {
        "click": _vm.tabLabel
      }
    }, [_vm._v("\n      " + _vm._s(item.label_name) + "\n    ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.listMode == 0 && _vm.normalList.length) ? _c('div', {
    class: ("tab_content " + (_vm.prizes.length && _vm.tabsConfig.tabs[_vm.tabsConfig.active] == '排行'? '' : 'gray'))
  }, _vm._l((_vm.normalList), function(poData, po_item_index) {
    return _c('div', {
      key: po_item_index,
      staticClass: "po_item"
    }, [(_vm.prizes.length > 0 && (po_item_index < _vm.prizes.length) && _vm.tabsConfig.tabs[_vm.tabsConfig.active] == '排行') ? _c('div', {
      class: ("prize_tag " + (po_item_index > 2 ? 'pink' : ''))
    }, [_c('div', {
      staticClass: "crown"
    }), _vm._v(" "), _c('div', {
      staticClass: "txt"
    }, [_vm._v("\n          " + _vm._s(_vm.prizes[po_item_index]) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
      class: ("po_top " + (_vm.prizes.length && po_item_index < _vm.prizes.length && _vm.tabsConfig.tabs[_vm.tabsConfig.active] == '排行' ? '' : 'margin'))
    }, [_c('div', {
      staticClass: "user_info"
    }, [_c('div', {
      staticClass: "avatar",
      style: ('background-image:url(' + poData.user.face + ')')
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('p', {
      class: 'user_name sex_' + poData.user.gender
    }, [_vm._v(_vm._s(poData.user.username))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("timestamp2txt")(poData.dateline)))])])]), _vm._v(" "), _c('div', {
      staticClass: "stamp",
      style: ('background-image:url(' + poData.tag_stick + ')')
    })]), _vm._v(" "), _c('div', {
      staticClass: "po_content"
    }, [_c('div', {
      staticClass: "po_txt",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(poData.id)
        }
      }
    }, [(_vm.tag_info) ? _c('span', {
      staticClass: "tag"
    }, [_vm._v(_vm._s('#' + _vm.tag_info.tag_name))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "poContent",
      domProps: {
        "innerHTML": _vm._s(_vm.contentFilters(poData.content))
      }
    })]), _vm._v(" "), _c('PicBox', {
      attrs: {
        "images": poData.images,
        "type": poData.type
      }
    }), _vm._v(" "), (poData.address) ? _c('div', {
      staticClass: "location",
      on: {
        "click": function($event) {
          return _vm.jumpLocation(poData.extra.position_x, poData.extra.position_y)
        }
      }
    }, [_vm._v(_vm._s(poData.address))]) : _vm._e()], 1), _vm._v(" "), (poData.labels.length) ? _c('div', {
      staticClass: "po-labels-list"
    }, [_c('span', {
      staticClass: "label-icon"
    }), _vm._v(" "), _vm._l((poData.labels), function(lItem, lIndex) {
      return _c('span', {
        key: ((poData.id) + "_" + lIndex),
        staticClass: "po-label",
        on: {
          "click": function($event) {
            return _vm.toLabel(lItem.label_id)
          }
        }
      }, [_vm._v("\n          " + _vm._s(lItem.label_name) + "\n        ")])
    })], 2) : _vm._e(), _vm._v(" "), (poData.praise_count > 0) ? _c('div', {
      staticClass: "zan_wrap",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(poData.id)
        }
      }
    }, [_c('div', {
      staticClass: "avatar_list"
    }, [_vm._l((poData.praise), function(item, index) {
      return (index < 9) ? _c('div', {
        key: index,
        staticClass: "avatar",
        style: ('background-image:url(' + item.face + ')')
      }) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "zan_count"
    }, [_vm._v(_vm._s(poData.praise_count <
      100 ? poData.praise_count + '赞' : '99+'))])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "comment_list",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(poData.id)
        }
      }
    }, [_vm._l((poData.comments), function(item, index) {
      return (index < 3) ? _c('div', {
        key: index,
        staticClass: "item"
      }, [_c('span', {
        class: 'user sex_' + item.cuinfo.gender
      }, [_vm._v(_vm._s(item.cuinfo.username))]), _vm._v(" "), (item.ruinfo.username) ? [_c('span', {
        staticClass: "to"
      }, [_vm._v("回复")]), _vm._v(" "), _c('span', {
        class: 'user sex_' + item.ruinfo.gender
      }, [_vm._v(_vm._s(item.ruinfo.username))])] : _vm._e(), _vm._v(" "), _c('span', [_vm._v("：")]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(item.comment)
        }
      })], 2) : _vm._e()
    }), _vm._v(" "), (poData.comment_count > 3) ? _c('div', {
      staticClass: "more"
    }, [_vm._v("\n                查看全部(" + _vm._s(poData.comment_count) + ")\n              ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "po_item_ctrl"
    }, [_c('div', {
      staticClass: "input_wrap",
      on: {
        "click": _vm.openAppTopic
      }
    }, [_vm._v("回复 " + _vm._s(poData.username))]), _vm._v(" "), _c('i', {
      staticClass: "share",
      on: {
        "click": _vm.openAppTopic
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "zan",
      class: poData.is_praise ? 'on' : '',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onZan(po_item_index)
        }
      }
    })])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.listMode == 1) ? _c('div', {
    staticClass: "tab_content"
  }, [_c('div', {
    staticClass: "water_fall"
  }, [_c('div', {
    staticClass: "col_wrap"
  }, [_c('div', {
    ref: "col_0"
  }, _vm._l((_vm.waterFall.col_0), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(item.id)
        }
      }
    }, [(item.views != 0) ? _c('div', {
      staticClass: "read_count"
    }, [_vm._v(_vm._s(item.views))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "img",
      style: (("background-image:url(" + (item.cover.url) + ");height:" + (item.cover.h) + "px;width:" + (item.cover.w) + "px;"))
    }, [(item.type == 2) ? _c('div', {
      staticClass: "mask"
    }, [_c('div', {
      staticClass: "video-btn"
    })]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user_n_time"
    }, [_c('div', {
      staticClass: "user-info"
    }, [_c('img', {
      staticClass: "user_avatar",
      attrs: {
        "src": item.user.face,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      class: 'username sex_' + item.user.gender
    }, [_vm._v(_vm._s(item.user.username))])]), _vm._v(" "), (item.praise_count != 0) ? _c('div', {
      staticClass: "praise-content"
    }, [_c('span', {
      staticClass: "praise-icon"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.praise_count))])]) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col_wrap"
  }, [_c('div', {
    ref: "col_1"
  }, _vm._l((_vm.waterFall.col_1), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(item.id)
        }
      }
    }, [(item.views != 0) ? _c('div', {
      staticClass: "read_count"
    }, [_vm._v(_vm._s(item.views))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "img",
      style: (("background-image:url(" + (item.cover.url) + ");height:" + (item.cover.h) + "px;width:" + (item.cover.w) + "px;"))
    }, [(item.type == 2) ? _c('div', {
      staticClass: "mask"
    }, [_c('div', {
      staticClass: "video-btn"
    })]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user_n_time"
    }, [_c('div', {
      staticClass: "user-info"
    }, [_c('img', {
      staticClass: "user_avatar",
      attrs: {
        "src": item.user.face,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      class: 'username sex_' + item.user.gender
    }, [_vm._v(_vm._s(item.user.username))])]), _vm._v(" "), (item.praise_count != 0) ? _c('div', {
      staticClass: "praise-content"
    }, [_c('span', {
      staticClass: "praise-icon"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.praise_count))])]) : _vm._e()])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.tabsConfig.active == 1) ? _c('div') : _vm._e(), _vm._v(" "), _c('BottomLoading', {
    style: (_vm.ifShowBottomLoading ? 'visibility:visible' : 'visibility:hidden')
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topic"
    }
  }, [(_vm.showCutscenes) ? _c('Cutscenes') : _vm._e(), _vm._v(" "), _c('download-nav'), _vm._v(" "), (_vm.activity) ? [(_vm.activity.image) ? _c('div', {
    staticClass: "top_pic",
    style: ('background-image:url(' + _vm.activity.image + ')')
  }) : _vm._e(), _vm._v(" "), (_vm.activity.tag_desc) ? _c('a', {
    staticClass: "topic_link",
    attrs: {
      "href": _vm.activity.url || 'javascript:;'
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v(_vm._s(_vm.activity.tag_desc))]), _vm._v(" "), _c('i', {
    staticClass: "arrow"
  })]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.tag_info) ? _c('div', {
    staticClass: "topic_content"
  }, [_c('p', {
    staticClass: "topic_name"
  }, [_vm._v("\n      " + _vm._s('#' + _vm.tag_info.tag_name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "counts"
  }, [_c('span', [_vm._v("感兴趣 " + _vm._s(_vm.tag_info.follow_count))]), _vm._v(" "), _c('span', [_vm._v("讨论 " + _vm._s(_vm.tag_info.thread_count))])]), _vm._v(" "), (_vm.tag_info.end_at != 0 && _vm.activityEndTime) ? _c('div', {
    staticClass: "count-down"
  }, [_c('span', {
    staticClass: "line"
  }), _vm._v(" "), (!_vm.activityEndTime.isEnd) ? _c('span', {
    staticClass: "txt"
  }, [_vm._v("剩余 " + _vm._s(_vm.activityEndTime.d) + "天 " + _vm._s(_vm.activityEndTime.h) + "时 " + _vm._s(_vm.activityEndTime.m) + "分 " + _vm._s(_vm.activityEndTime.s) + "秒")]) : _c('span', {
    staticClass: "txt"
  }, [_vm._v("活动已结束")]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "topic_desc"
  }, [_vm._v("\n      " + _vm._s(_vm.tag_info.tag_desc) + "\n    ")]), _vm._v(" "), (_vm.topicMode != 0) ? _c('a', {
    staticClass: "detail_btn",
    attrs: {
      "href": _vm.tag_info.url
    }
  }, [_vm._v("查看详情")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.tabsConfig.tabs.length) ? _c('tab-nav', {
    attrs: {
      "tabs": _vm.tabsConfig.tabs,
      "active": _vm.tabsConfig.active
    },
    on: {
      "change": _vm.tabChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.listMode == 0 && _vm.normalList.length) ? _c('div', {
    staticClass: "tab_content"
  }, _vm._l((_vm.normalList), function(poData, po_item_index) {
    return _c('div', {
      key: po_item_index,
      staticClass: "po_item"
    }, [_c('div', {
      staticClass: "po_top"
    }, [_c('div', {
      staticClass: "user_info"
    }, [_c('div', {
      staticClass: "avatar",
      style: ('background-image:url(' + poData.face + ')')
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('p', {
      class: 'user_name sex_' + poData.gender
    }, [_vm._v(_vm._s(poData.username))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("timestamp2txt")(poData.dateline)))])])]), _vm._v(" "), _c('div', {
      staticClass: "stamp",
      style: ('background-image:url(' + poData.tag_stick + ')')
    })]), _vm._v(" "), _c('div', {
      staticClass: "po_content"
    }, [_c('p', {
      staticClass: "po_txt",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(poData.id)
        }
      }
    }, [_c('span', {
      staticClass: "tag"
    }, [_vm._v(_vm._s('#' + _vm.tag_info.tag_name))]), _vm._v(" "), _c('span', {
      staticClass: "poContent",
      domProps: {
        "innerHTML": _vm._s(poData.content)
      }
    })]), _vm._v(" "), (poData.extra.titlte) ? _c('a', {
      staticClass: "po_tag",
      attrs: {
        "href": poData.extra.url
      }
    }, [_c('span', {
      staticClass: "txt"
    }, [_vm._v("\n            " + _vm._s(poData.extra.titlte) + "\n          ")]), _vm._v(" "), _c('i', {
      staticClass: "arrow"
    })]) : _vm._e(), _vm._v(" "), (poData.prize) ? _c('div', {
      staticClass: "prize_tag"
    }, [_c('div', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(poData.prize))])]) : _vm._e(), _vm._v(" "), _c('PicBox', {
      attrs: {
        "images": poData.images,
        "type": poData.type
      }
    }), _vm._v(" "), (poData.address) ? _c('div', {
      staticClass: "location",
      on: {
        "click": function($event) {
          return _vm.jumpLocation(poData.extra.position_x, poData.extra.position_y)
        }
      }
    }, [_vm._v(_vm._s(poData.address))]) : _vm._e()], 1), _vm._v(" "), (poData.praise_count > 0) ? _c('div', {
      staticClass: "zan_wrap",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(poData.id)
        }
      }
    }, [_c('div', {
      staticClass: "avatar_list"
    }, [_vm._l((poData.praise), function(item, index) {
      return (index < 9) ? _c('div', {
        key: index,
        staticClass: "avatar",
        style: ('background-image:url(' + item.face + ')')
      }) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "zan_count"
    }, [_vm._v(_vm._s(poData.praise_count <
      100 ? poData.praise_count + '赞' : '99+'))])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "comment_list",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(poData.id)
        }
      }
    }, [_vm._l((poData.comments), function(item, index) {
      return (index < 3) ? _c('div', {
        key: index,
        staticClass: "item"
      }, [_c('span', {
        class: 'user sex_' + item.cuinfo.gender
      }, [_vm._v(_vm._s(item.cuinfo.username))]), _vm._v(" "), (item.ruinfo.username) ? [_c('span', {
        staticClass: "to"
      }, [_vm._v("回复")]), _vm._v(" "), _c('span', {
        class: 'user sex_' + item.ruinfo.gender
      }, [_vm._v(_vm._s(item.ruinfo.username))])] : _vm._e(), _vm._v(" "), _c('span', [_vm._v("：")]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(item.comment)
        }
      })], 2) : _vm._e()
    }), _vm._v(" "), (poData.comment_count > 3) ? _c('div', {
      staticClass: "more"
    }, [_vm._v("\n            查看全部(" + _vm._s(poData.comment_count) + ")\n          ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "po_item_ctrl"
    }, [_c('div', {
      staticClass: "input_wrap",
      on: {
        "click": _vm.openAppTopic
      }
    }, [_vm._v("回复 " + _vm._s(poData.username))]), _vm._v(" "), _c('i', {
      staticClass: "share",
      on: {
        "click": _vm.openAppTopic
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "zan",
      class: poData.is_praise ? 'on' : '',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onZan(po_item_index)
        }
      }
    })])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.listMode == 1) ? _c('div', {
    staticClass: "tab_content"
  }, [_c('div', {
    staticClass: "water_fall"
  }, [_c('div', {
    staticClass: "col_wrap"
  }, [_c('div', {
    ref: "col_0"
  }, _vm._l((_vm.waterFall.col_0), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "read_count"
    }, [_vm._v(_vm._s(item.views))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": item.images[0].url,
        "width": item.images[0].w,
        "height": item.images[0].h
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user_n_time"
    }, [_c('span', {
      class: 'sex_' + item.gender
    }, [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("timestamp2txt")(item.dateline)))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col_wrap"
  }, [_c('div', {
    ref: "col_1"
  }, _vm._l((_vm.waterFall.col_1), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "read_count"
    }, [_vm._v(_vm._s(item.views))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": item.images[0].url,
        "width": item.images[0].w,
        "height": item.images[0].h
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user_n_time"
    }, [_c('span', {
      class: 'sex_' + item.gender
    }, [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("timestamp2txt")(item.dateline)))])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.tabsConfig.active == 1) ? _c('div') : _vm._e(), _vm._v(" "), _c('BottomLoading', {
    style: (_vm.ifShowBottomLoading ? 'visibility:visible' : 'visibility:hidden')
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "detail"
    }
  }, [(_vm.showCutscenes) ? _c('Cutscenes') : _vm._e(), _vm._v(" "), _c('DownloadNav'), _vm._v(" "), (_vm.poData) ? [(_vm.poData.tags && _vm.poData.tags.length) ? _c('div', {
    staticClass: "topic"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'topic',
        params: {
          tag_id: _vm.poData.tags[0].tag_id
        }
      }
    }
  }, [_vm._v("\n        #" + _vm._s(_vm.poData.tags[0].tag_name) + "\n      ")]), _vm._v(" "), _c('span', [_vm._v("话题讨论 " + _vm._s(_vm.poData.tags[0].thread_count))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "po_main"
  }, [_c('div', {
    staticClass: "po_top"
  }, [_c('div', {
    staticClass: "user_info"
  }, [_c('div', {
    staticClass: "avatar",
    style: ('background-image:url(' + _vm.poData.face + ')')
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    class: 'user_name sex_' + _vm.poData.gender
  }, [_vm._v(_vm._s(_vm.poData.username))]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("timestamp2txt")(_vm.poData.dateline)))])])]), _vm._v(" "), (_vm.poData.tags && _vm.poData.tags.length) ? _c('div', {
    staticClass: "stamp",
    style: ('background-image:url(' + _vm.poData.tags[0].tag_stick + ')')
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "po_content"
  }, [_c('p', {
    staticClass: "po_txt",
    domProps: {
      "innerHTML": _vm._s(_vm.poData.content)
    }
  }), _vm._v(" "), (_vm.poData.extra.titlte) ? _c('a', {
    staticClass: "po_tag",
    attrs: {
      "href": _vm.poData.extra.url
    }
  }, [_c('span', {
    staticClass: "txt"
  }, [_vm._v("\n            " + _vm._s(_vm.poData.extra.titlte) + "\n          ")]), _vm._v(" "), _c('i', {
    staticClass: "arrow"
  })]) : _vm._e(), _vm._v(" "), (_vm.poData.images) ? _c('PicBox', {
    attrs: {
      "images": _vm.poData.images,
      "type": _vm.poData.type
    }
  }) : _vm._e(), _vm._v(" "), (_vm.poData.address) ? _c('div', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.poData.address))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "po_ctrl"
  }, [_c('div', {
    staticClass: "item",
    on: {
      "click": _vm.openApp
    }
  }, [_c('div', {
    staticClass: "icon comment_btn"
  }), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("评论")])]), _vm._v(" "), (_vm.poData.is_praise) ? _c('div', {
    staticClass: "item on",
    on: {
      "click": _vm.onZan
    }
  }, [_c('div', {
    staticClass: "icon zan_btn"
  }), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("已赞")])]) : _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.onZan
    }
  }, [_c('div', {
    staticClass: "icon zan_btn"
  }), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("点赞")])])]), _vm._v(" "), (_vm.poData.praise && _vm.poData.praise.length) ? _c('div', {
    staticClass: "zan_wrap"
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("他们点了赞(" + _vm._s(_vm.poData.praise.length) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "avatar_list"
  }, [_vm._l((_vm.poData.praise), function(item, index) {
    return (index < 7) ? _c('div', {
      key: index,
      staticClass: "avatar",
      style: ('background-image:url(' + item.face + ')')
    }) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "zan_count"
  }, [_vm._v(_vm._s(_vm.poData.praise.length) + "赞")]), _vm._v(" "), _c('i', {
    staticClass: "arrow"
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "comments"
  }, [_c('div', {
    staticClass: "circle-tit"
  }, [_c('i', {
    staticClass: "circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "txt"
  }, [_vm._v("评论" + _vm._s(_vm.poData.comment_count == 0 ? '' : ' (' + _vm.poData.comment_count + ')'))])]), _vm._v(" "), (_vm.poData.comments) ? [_c('div', {
    staticClass: "comment-list"
  }, _vm._l((_vm.poData.comments), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "comment-item"
    }, [_c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "user_info"
    }, [_c('div', {
      staticClass: "avatar",
      style: ('background-image:url(' + item.cuinfo.face + ')')
    }), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('p', {
      staticClass: "user_name"
    }, [_c('span', {
      class: 'nick sex_' + item.cuinfo.gender
    }, [_vm._v(_vm._s(item.cuinfo.username))]), _vm._v(" "), (item.ruinfo.username) ? [_c('span', {
      staticClass: "to"
    }, [_vm._v("回复")]), _vm._v(" "), _c('span', {
      class: 'nick sex_' + item.ruinfo.gender
    }, [_vm._v(_vm._s(item.ruinfo.username))])] : _vm._e()], 2), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("timestamp2txt")(item.dateline)))])])]), _vm._v(" "), _c('p', {
      staticClass: "comment-txt",
      domProps: {
        "innerHTML": _vm._s(item.comment)
      }
    })])
  }), 0), _vm._v(" "), (_vm.poData.comment_count - _vm.poData.comments.length > 0) ? _c('a', {
    staticClass: "big-btn",
    on: {
      "click": _vm.loadComment
    }
  }, [_vm._v("\n          更多精彩评论（" + _vm._s(_vm.poData.comment_count - _vm.poData.comments.length) + "条）\n        ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.poData.comment_count == 0) ? _c('div', {
    staticClass: "no_comment"
  }, [_c('p', [_vm._v("暂无评论")]), _vm._v(" "), _c('p', [_vm._v("快快抢沙发")])]) : _vm._e()], 2), _vm._v(" "), (_vm.poData.recommend) ? _c('div', {
    staticClass: "others"
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    staticClass: "pic",
    attrs: {
      "src": _vm.poData.recommend.tag_img
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tag"
  }, [_vm._v("#" + _vm._s(_vm.poData.recommend.tag_name) + "#")]), _vm._v(" "), _c('p', {
    staticClass: "count"
  }, [_vm._v("已有" + _vm._s(_vm.poData.recommend.thread_count) + "份作品")]), _vm._v(" "), _c('a', {
    staticClass: "big-btn",
    on: {
      "click": function($event) {
        return _vm.openAppPoTopic(_vm.poData.recommend.tag_id)
      }
    }
  }, [_vm._v("我要参与")])]) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "circle-tit"
  }, [_c('i', {
    staticClass: "circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "txt"
  }, [_vm._v("大家都在Po")])])
}]}

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom_loading"
  })
},staticRenderFns: []}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download_nav",
    class: _vm.ifShow ? 'show' : 'hide'
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn",
    on: {
      "click": _vm.openApp
    }
  }, [_vm._v("App内打开")])])])
},staticRenderFns: []}

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "map"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.label_info) ? _c('div', {
    attrs: {
      "id": "topic"
    }
  }, [(_vm.showCutscenes) ? _c('Cutscenes') : _vm._e(), _vm._v(" "), _c('DownloadNav', {
    attrs: {
      "ifShow": _vm.ifShow
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tag-info"
  }, [_c('div', {
    staticClass: "background",
    style: (("background-image:url(" + (_vm.label_info.label_cover) + ")"))
  }), _vm._v(" "), (_vm.label_info.brand && Object.keys(_vm.label_info.brand).length > 0) ? _c('div', {
    staticClass: "business-tag"
  }, [_c('div', {
    staticClass: "shop-info"
  }, [_c('img', {
    staticClass: "shop-logo",
    attrs: {
      "src": _vm.label_info.label_icon,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "shop-name"
  }, [_vm._v(_vm._s(_vm.label_info.label_name))])]), _vm._v(" "), _c('div', {
    staticClass: "shop-detail"
  }, [_vm._v("\n        " + _vm._s(_vm.label_info.brand.brand_desc) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "comments-count"
  }, [_vm._v("讨论 " + _vm._s(_vm.label_info.thread_count))])]) : _c('div', {
    staticClass: "normal-tag"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('span', {
    staticClass: "tag-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "tag-name"
  }, [_vm._v(_vm._s(_vm.label_info.label_name))])]), _vm._v(" "), _c('div', {
    staticClass: "comments-count"
  }, [_vm._v("讨论 " + _vm._s(_vm.label_info.thread_count))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab_content",
    attrs: {
      "id": "tab_content"
    }
  }, [(_vm.label_info.location && Object.keys(_vm.label_info.location).length > 0) ? _c('div', {
    staticClass: "map-info",
    on: {
      "click": function($event) {
        return _vm.toMap(_vm.label_info.location.latitude, _vm.label_info.location.longitude)
      }
    }
  }, [_c('div', {
    staticClass: "address"
  }, [_c('span', [_vm._v("地址：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.label_info.location.location_detail))])]), _vm._v(" "), _c('span', {
    staticClass: "map-icon"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "water_fall"
  }, [_c('div', {
    staticClass: "col_wrap"
  }, [_c('div', {
    ref: "col_0"
  }, _vm._l((_vm.waterFall.col_0), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "read_count"
    }, [_vm._v(_vm._s(item.views))]), _vm._v(" "), _c('div', {
      staticClass: "img",
      style: (("background-image:url(" + (item.cover.hd_url) + ");background-size: cover;background-position: center;background-repeat: no-repeat;height:" + (item.cover.h) + "px;width:" + (item.cover.w) + "px;"))
    }, [(item.type == 2) ? _c('div', {
      staticClass: "mask"
    }, [_c('div', {
      staticClass: "video-btn"
    })]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user_n_time"
    }, [_c('div', {
      staticClass: "user-info"
    }, [_c('img', {
      staticClass: "user_avatar",
      attrs: {
        "src": item.user.face,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      class: 'username sex_' + item.user.gender
    }, [_vm._v(_vm._s(item.user.username))])]), _vm._v(" "), _c('div', {
      staticClass: "praise-content"
    }, [_c('span', {
      staticClass: "praise-icon"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.praise_count))])])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col_wrap"
  }, [_c('div', {
    ref: "col_1"
  }, _vm._l((_vm.waterFall.col_1), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "read_count"
    }, [_vm._v(_vm._s(item.views))]), _vm._v(" "), _c('div', {
      staticClass: "img",
      style: (("background-image:url(" + (item.cover.hd_url) + ");background-size: cover;background-position: center;background-repeat: no-repeat;height:" + (item.cover.h) + "px;width:" + (item.cover.w) + "px;"))
    }, [(item.type == 2) ? _c('div', {
      staticClass: "mask"
    }, [_c('div', {
      staticClass: "video-btn"
    })]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user_n_time"
    }, [_c('div', {
      staticClass: "user-info"
    }, [_c('img', {
      staticClass: "user_avatar",
      attrs: {
        "src": item.user.face,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      class: 'username sex_' + item.user.gender
    }, [_vm._v(_vm._s(item.user.username))])]), _vm._v(" "), _c('div', {
      staticClass: "praise-content"
    }, [_c('span', {
      staticClass: "praise-icon"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.praise_count))])])])])
  }), 0)])]), _vm._v(" "), _c('p', {
    staticClass: "upload-tips",
    on: {
      "click": function($event) {
        return _vm.openApp(_vm.noMoreData)
      }
    }
  }, [_vm._v(_vm._s(!_vm.noMoreData ? (_vm.loading ? '正在加载中' : '上拉加载更多哦') : '啊哦加载完了，打开app查看更多有趣的话题吧') + "~")])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cutscenes"
  }, [_c('i', {
    staticClass: "xiaoxi"
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("加载中...")])])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'detail'
  }, [(_vm.showCutscenes) ? _c('Cutscenes') : _vm._e(), _vm._v(" "), _c('DownloadNav', {
    attrs: {
      "ifShow": _vm.ifShow
    }
  }), _vm._v(" "), _c('div', {
    class: 'detail-content'
  }, [(_vm.poData && _vm.poData.images.length && !_vm.isVideo) ? _c('div', {
    staticClass: "swipe-box"
  }, [_c('Swipe', {
    staticClass: "swipe-content",
    attrs: {
      "showIndicators": false,
      "auto": 0,
      "continuous": false
    },
    on: {
      "change": _vm.handleChange
    }
  }, _vm._l((_vm.poData.images), function(item, index) {
    return _c('SwipeItem', {
      key: item.url,
      attrs: {
        "alt": index
      }
    }, [_c('div', {
      staticClass: "carouse-item",
      style: (("background-image:url(" + (item.hd_url) + ")"))
    })])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "post-info-bottom"
  }, [_c('div', {
    staticClass: "post-info-left"
  }, [_c('div', {
    staticClass: "likers"
  }, _vm._l((_vm.poData.praise), function(item, index) {
    return (index < 3) ? _c('img', {
      key: index,
      staticClass: "likers-avatar",
      attrs: {
        "src": item.face,
        "alt": "",
        "srcset": ""
      }
    }) : _vm._e()
  }), 0), _vm._v(" "), (parseInt(_vm.poData.praise_count) != 0) ? _c('span', [_vm._v(_vm._s(_vm.poData.praise_count) + "赞")]) : _vm._e(), _vm._v(" "), (parseInt(_vm.poData.collect_count) != 0) ? _c('span', [_vm._v(_vm._s(_vm.poData.collect_count) + "收藏")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "post-info-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.poData.views) + "阅读")])])]), _vm._v(" "), (_vm.poData.images.length > 1) ? _c('span', {
    staticClass: "indicators"
  }, [_vm._v(_vm._s(_vm.poData.images.length > 1 ? _vm.swipeIndex + 1 : 1) + "/" + _vm._s(_vm.poData.images.length))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.poData && _vm.isVideo) ? _c('div', {
    class: 'video ' + (_vm.playing ? 'full' : '')
  }, [_c('video', {
    ref: "video",
    attrs: {
      "webkit-playsinline": "",
      "playsinline": "",
      "x5-playsinline": "",
      "x-webkit-airplay": "allow",
      "poster": _vm.poData.images[0].url,
      "src": _vm.poData.images[1].url
    },
    on: {
      "click": _vm.playVideo,
      "ended": _vm.ended
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "video-btn",
    attrs: {
      "hidden": _vm.playing
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.playVideo($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "post-info-bottom"
  }, [_c('div', {
    staticClass: "post-info-left"
  }, [_c('div', {
    staticClass: "likers"
  }, _vm._l((_vm.poData.praise), function(item, index) {
    return (index < 3) ? _c('img', {
      key: index,
      staticClass: "likers-avatar",
      attrs: {
        "src": item.face,
        "alt": "",
        "srcset": ""
      }
    }) : _vm._e()
  }), 0), _vm._v(" "), _c('span', [_vm._v(_vm._s(parseInt(_vm.poData.praise_count)) + "赞")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(parseInt(_vm.poData.collect_count)) + "收藏")])]), _vm._v(" "), _c('div', {
    staticClass: "post-info-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.poData.views) + "阅读")])])])]) : _vm._e(), _vm._v(" "), (_vm.poData) ? _c('div', {
    staticClass: "post-info"
  }, [_c('div', {
    staticClass: "post-user"
  }, [_c('div', {
    staticClass: "post-user-left"
  }, [_c('img', {
    staticClass: "user-avatar",
    attrs: {
      "src": _vm.poData.user.face,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    class: 'user-nickname ' + 'sex_' + _vm.poData.user.gender
  }, [_vm._v(_vm._s(_vm.poData.user.username))]), _vm._v(" "), _c('span', {
    staticClass: "user-po-time"
  }, [_vm._v(_vm._s(_vm._f("timestamp2txt")(_vm.poData.dateline)))])]), _vm._v(" "), _c('div', {
    staticClass: "post-identity"
  }, [_vm._l((_vm.poData.user.icons), function(item, index) {
    return _c('img', {
      key: index,
      staticClass: "post-medal",
      attrs: {
        "src": item,
        "alt": ""
      }
    })
  }), _vm._v(" "), _vm._l((_vm.poData.user.medals), function(item, index) {
    return _c('img', {
      key: item.medal_id,
      staticClass: "post-medal",
      attrs: {
        "src": item.medal_icon,
        "alt": index
      }
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "post-user-right"
  }, [(_vm.poData.tag.tag_stick || _vm.poData.sticker) ? _c('img', {
    staticClass: "po-sticker",
    attrs: {
      "src": _vm.poData.tag.tag_stick || _vm.poData.sticker,
      "alt": ""
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "post-content"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.poData.tag && _vm.poData.tag.tag_id),
      expression: "poData.tag && poData.tag.tag_id"
    }],
    staticClass: "tag",
    on: {
      "click": function($event) {
        return _vm.toTag(_vm.poData.tag.tag_id)
      }
    }
  }, [_vm._v("#" + _vm._s(_vm.poData.tag.tag_name))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentFilters(_vm.poData.content))
    }
  })]), _vm._v(" "), (_vm.poData.labels.length != 0) ? _c('div', {
    staticClass: "post-tags"
  }, [_c('span', {
    staticClass: "tag-icon margin"
  }), _vm._v(" "), _vm._l((_vm.poData.labels), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "tag margin",
      on: {
        "click": function($event) {
          return _vm.toLabel(item.label_id)
        }
      }
    }, [_vm._v(_vm._s(item.label_name))])
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.poData && _vm.poData.comments.length) ? _c('div', {
    staticClass: "comments"
  }, [
    [_c('div', {
      staticClass: "comment-list"
    }, _vm._l((_vm.poData.comments), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "comment-item"
      }, [_c('div', {
        staticClass: "line"
      }), _vm._v(" "), _c('div', {
        staticClass: "user_info"
      }, [_c('div', {
        staticClass: "user_info_left"
      }, [_c('div', {
        staticClass: "avatar",
        style: ('background-image:url(' + item.cuinfo.face + ')')
      }), _vm._v(" "), _c('p', {
        staticClass: "user_name"
      }, [_c('span', {
        class: 'nick sex_' + item.cuinfo.gender
      }, [_vm._v(_vm._s(item.cuinfo.username))]), _vm._v(" "), (item.ruinfo.uid) ? _c('span', [_vm._v("\n                    回复\n                    "), _c('span', {
        class: 'nick sex_' + item.ruinfo.gender
      }, [_vm._v(_vm._s(item.ruinfo.username))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
        staticClass: "time"
      }, [_vm._v(_vm._s(_vm._f("timestamp2txt")(item.dateline)))])]), _vm._v(" "), _c('p', {
        staticClass: "comment-txt",
        domProps: {
          "innerHTML": _vm._s(item.comment)
        }
      })])
    }), 0)]
  ], 2) : _vm._e(), _vm._v(" "), (parseInt(_vm.poData.comment_count) > 0 && _vm.from_admin == 0) ? _c('div', {
    staticClass: "all-comments",
    on: {
      "click": _vm.downApp
    }
  }, [(parseInt(_vm.poData.comment_count) > 3) ? _c('div', {
    staticClass: "check-all-comments"
  }, [_vm._v("\n        打开西子湖畔App 查看全部" + _vm._s(parseInt(_vm.poData.comment_count)) + "条评论\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.hotList.length > 0 && _vm.from_admin == 0) ? _c('div', {
    staticClass: "tab_content",
    attrs: {
      "id": "tab_content"
    }
  }, [_c('h1', [_vm._v("话题相关")]), _vm._v(" "), _c('div', {
    staticClass: "water_fall"
  }, [_c('div', {
    staticClass: "col_wrap"
  }, [_c('div', {
    ref: "col_0"
  }, _vm._l((_vm.waterFall.col_0), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(item.id)
        }
      }
    }, [(item.views != 0) ? _c('div', {
      staticClass: "read_count"
    }, [_vm._v("\n                " + _vm._s(item.views) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "img",
      style: (("background-image:url(" + (item.cover.hd_url) + ");height:" + (item.cover.h) + "px;width:" + (item.cover.w) + "px;"))
    }, [(item.type == 2) ? _c('div', {
      staticClass: "mask"
    }, [_c('div', {
      staticClass: "video-btn"
    })]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user_n_time"
    }, [_c('div', {
      staticClass: "user-info"
    }, [_c('img', {
      staticClass: "user_avatar",
      attrs: {
        "src": item.user.face,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      class: 'username sex_' + item.user.gender
    }, [_vm._v(_vm._s(item.user.username))])]), _vm._v(" "), (parseInt(item.praise_count) != 0) ? _c('div', {
      staticClass: "praise-content"
    }, [_c('span', {
      staticClass: "praise-icon"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(parseInt(item.praise_count)))])]) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col_wrap"
  }, [_c('div', {
    ref: "col_1"
  }, _vm._l((_vm.waterFall.col_1), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(item.id)
        }
      }
    }, [(item.views != 0) ? _c('div', {
      staticClass: "read_count"
    }, [_vm._v("\n                " + _vm._s(item.views) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "img",
      style: (("background-image:url(" + (item.cover.hd_url) + ");height:" + (item.cover.h) + "px;width:" + (item.cover.w) + "px;"))
    }, [(item.type == 2) ? _c('div', {
      staticClass: "mask"
    }, [_c('div', {
      staticClass: "video-btn"
    })]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user_n_time"
    }, [_c('div', {
      staticClass: "user-info"
    }, [_c('img', {
      staticClass: "user_avatar",
      attrs: {
        "src": item.user.face,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      class: 'username sex_' + item.user.gender
    }, [_vm._v(_vm._s(item.user.username))])]), _vm._v(" "), (item.praise_count != 0) ? _c('div', {
      staticClass: "praise-content"
    }, [_c('span', {
      staticClass: "praise-icon"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.praise_count))])]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('p', {
    staticClass: "upload-tips",
    on: {
      "click": function($event) {
        return _vm.openApp(_vm.noMoreData)
      }
    }
  }, [_vm._v("\n        " + _vm._s(!_vm.noMoreData ?
    !_vm.loaded ?
    "正在加载中" :
    "上拉加载更多哦" :
    "啊哦加载完了，打开app查看更多有趣的话题吧") + "~\n      ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.playing),
      expression: "!playing"
    }],
    staticClass: "bottom-panel"
  }, [_c('div', {
    staticClass: "fake-input",
    on: {
      "click": _vm.downApp
    }
  }, [_vm._v("赞是喜欢，评论是爱")]), _vm._v(" "), _c('div', {
    staticClass: "operations"
  }, [_c('div', {
    class: ("like " + (_vm.poData.is_praise == 1 ? 'liked' : '')),
    on: {
      "click": _vm.onZan
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "collection",
    on: {
      "click": _vm.downApp
    }
  })])])], 1)
},staticRenderFns: []}

/***/ })
],[68]);


// WEBPACK FOOTER //
// static/js/app.7e10d8ddcb225b3ab75f.js